import { useContext, useEffect, useRef, useState } from 'react'
import PageHead from '../../Components/PageHead'
import { convertToBase64, getAllBuildings, getpostalcodes, LogInSchoolID, LogInUserID, MMDDYYYY, onKeyDownRestrict, onPasteRestriction, origin, typewatch, ymdToDate, YYYYMMDD } from '../../JS/Common';
import { ApiGetCall, ApiGetCDNData, ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext, UserContext } from '../../App';
import { Accordion, OverlayTrigger, Popover } from 'react-bootstrap';
import BuildingAddressPopup from './BuildingAddressPopup';
import ContactsAccordion from './ContactsAccordion';
import Deletepopup from '../../Components/Deletepopup';
import { log } from '../../JS/Logger';
import CustomReactDatePicker from '../../Components/CustomReactDatePicker';
import { useSelector } from 'react-redux';
import { store } from '../../Store/Store';
import useConfig from '../../Hooks/useConfig';

export default function SchoolProfile() {
    const { state } = useContext(ThemeContext);
    const { user_num_keyword, account_name_keyword, show_partnership_reseller, show_part_order_module,
        organization, show_device_complete_club, student_no, enterprise_name, coverage, primary_text,
        adminCallNode, show_pricing_default_custom, left_menu_white_logo, dcc_module_text } = useConfig();
    const organizationLabelSmall = organization?.toLowerCase();
    const StateData = useSelector((state) => state.authData);
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [adperror, setAdperror] = useState("");
    const [asperror, setAsperror] = useState("");
    const [deletePopup, setDeletePopup] = useState({
        show: false,
        item: null
    })
    const location = useLocation();
    const { UserData, setUserData } = useContext(UserContext);
    const stateRedux = store.getState();
    const adminSchoolId = location?.state?.schoolid;
    const fromadminorschool = location?.state?.flag;
    const schoolname = location?.state?.schoolname;
    const navigate = useNavigate();
    const ShippingType = state?.ShippingType;
    const ImportDevicesFile = useRef();
    const deviceDistricts = [
        { id: 1, name: "Acer" },
        { id: 2, name: "Apple" },
        { id: 3, name: "Asus" },
        { id: 4, name: "Dell" },
        { id: 5, name: "HP" },
        { id: 6, name: "Lenovo" },
        { id: 7, name: "Samsung" }
    ];
    let repairCoverage = [
        { id: 1, name: "ASP Warranty Repairs" },
        { id: 2, name: "Ad-Hoc Repairs" },
        { id: 3, name: "ADP" },
    ];

    if (show_device_complete_club) {
        repairCoverage.push({ id: 4, name: dcc_module_text });
    }

    const minimumRepairGrade = [
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
    ];
    const routeDay = [
        { id: 1, name: "Monday" },
        { id: 2, name: "Tuesday" },
        { id: 3, name: "Wednesday" },
        { id: 4, name: "Thursday" },
        { id: 5, name: "Friday" }
    ];
    const routeFrequency = [
        { id: 1, name: "Weekly" },
        { id: 2, name: "Bi-Weekly" },
        { id: 3, name: "Monthly" },
        { id: 4, name: "As-Needed" }
    ];
    const repairPriceTier = [
        { id: 1, name: "Bronze" },
        { id: 2, name: "Silver" },
        { id: 3, name: "Gold" },
        { id: 4, name: "Special" },
    ];
    const cosmeticDamage = [
        { id: 1, name: "Rubber Feet" },
        { id: 2, name: "Hinge Cover" },
        { id: 3, name: "Screw Cover" },
        { id: 4, name: "Stickers" }
    ];
    const exceedingCapHandling = [
        { id: 1, name: "Quote Repair" },
        { id: 2, name: "Quote Replacement" },
        { id: 3, name: "Send Back Unrepaired" },
        { id: 4, name: "eRecycle" },
        { id: 5, name: "Other" },
    ];
    const devicesTakeHome = [
        { id: 1, name: "Summer" },
        { id: 2, name: "Spring" },
        { id: 3, name: "Winter" },
        { id: 4, name: "Not Sent Home" },
    ];
    const quotingNeeded = [
        { id: 1, name: "Yes ($35/each device)" },
        { id: 2, name: "No" },
    ];
    const additionalAssetManagement = [
        { id: 1, name: "Asset Panda" },
        { id: 2, name: "Incident IQ" },
        { id: 3, name: "One-to-One Plus" },
        { id: 4, name: "Self-Developed" },
        { id: 5, name: "Other" }
    ];
    const accountCreditUsage = [
        { id: 1, name: "Accessories" },
        { id: 2, name: "ADP" },
        { id: 3, name: "Buyback" },
        { id: 4, name: "Devices" },
        { id: 5, name: "Repairs" }
    ];
    const uncoveredDevices = [
        { id: 1, name: "Quote ($35/each device)" },
        { id: 2, name: "Repair" },
        { id: 3, name: "Send Back" },
        { id: 4, name: "Other" },
    ];
    const methodOfContact = [
        { id: 1, name: "Call" },
        { id: 2, name: "Text" },
        { id: 3, name: "Email" },
    ];

    const [AllState, setallstate] = useState([]);
    const [postImage, setPostImage] = useState({ myFile: "" });
    const [showPopover, setShowPopover] = useState(false);
    const [relationshipshowPopover, setRelationshipshowPopover] = useState(false);
    const [drivershowPopover, setdriverhowPopover] = useState(false);
    const [callHubspot, setCallHubSpot] = useState(false);

    const [SchoolProfile, setSchoolProfile] = useState({
        enrollment: "",
        customer: "",
        pricing: 0,
        domain: '',
        partsOrder: null,
        RCS: null,
        FileName: '',
        Document: '',
        approvalStatus: 0
    });
    const [shippingDetails, setShippingDetails] = useState({
        fedex_company_name: "",
        Phoneno: "",
        Street1: "",
        Street2: "",
        city: "",
        state: "",
        postalcode: "",
        shippingextension: "",
        pickuplocations: [],
        buildingname: ""
    });
    const [billingDetails, setBillingDetails] = useState({
        accountcredit: "",
        discoutpricing: '',
        accountcreditusage: [],
        accountcreditusagenotes: '',
        customerid: '',
        UseSecondaryPricing: 2, // 1 means yes, 2 means no
    });
    const [contactInformation, setContactInformation] = useState({
        email: "",
        firstname: "",
        lastname: "",
        jobtitle: "",
        phonenumber: "",
        phonetype: "",
        contactextension: '',
        methodOfContact: [],
        accesstype: '',
        otheremail: '',
    });
    const [deviceInformation, setDeviceInformation] = useState({
        weeklyrepairs: "",
        devicesindistrict: []
    });
    const [repairDetails, setRepairDetails] = useState({
        quotingNeeded: "",
        minRepairGrade: "",
        repairPriceTier: "",
        routeDay: '',
        routeFrequency: '',
        cosmeticDamageRepaird: '',
        cosmeticdamageNotes: '',
        selectedDamageRepaird: [],
        deductible: '',
        deductibleNotes: '',
        repairNotes: '',
        repairCoverage: [],
        uncovereddevice: '',
        repairCoverageDetails: [],
        uncovereddeviceNotes: '',
        repairpricetiernotes: '',
        additionalAssetNotes: '',
        schoolclosetickets: 2
    });
    const [loanerAsset, setLoanerAsset] = useState({
        countofLoanerDevice: '',
        additionalAssets: []
    });
    const [k12TechData, setK12TechData] = useState({
        relationShipManager: '',
        locationManager: '',
        driver: '',
        startDate: '',
        relationShipManagerEmail: '',
        relationShipManagerContact: '',
        LocationManagerEmail: '',
        LocationManagerContact: '',
        partnership: '',
        driverEmail: '',
        driverContact: '',
    });
    const [invoiceDescription, setInvoiceDescription] = useState('{$serialNum} - {$attachPartsDetails}');

    const [staffEmails, setStaffEmails] = useState([]);
    const [allRelationShipManager, setAllRelationShipManager] = useState([]);
    const [allLocationManager, setAllLocationManager] = useState([]);
    const [allDriver, setAllDriver] = useState([]);
    const [allPickUpLocations, setAllPickUpLocations] = useState([]);
    const [errors, setErrors] = useState({});
    const [ASProws, setASProws] = useState([]);
    const [ADProws, setADProws] = useState([]);
    const [repairCoverageData, setRepairCoverageData] = useState({
        adhoc_carted: 0,
        adhoc_cases: 0,
        adhoc_screen: 0,
        adhoc_id: 0,
        parental_carted: 0,
        parental_cases: 0,
        parental_screen: 0,
        parental_id: 0
    })
    const [logins, setLogins] = useState([]);
    const [activeKeys, setActiveKeys] = useState(['0', '1', '2', '3', '4']);
    const [repairCapRows, setRepairCapRows] = useState([]);
    const [mailingaddress, setMailingAddress] = useState(0);
    const [mainshippinglocation, setMainShippingLocation] = useState(0);
    const [pickupTimingForSchool, setPickupTimingForSchool] = useState(2);
    const [showAddressPopover, setShowAddressPopover] = useState(false);
    const [buildingAddressPopup, setBuildingAddressPopup] = useState(false);
    const [selectedBuildingAddress, setSelectedBuildingAddress] = useState({});
    const [deviceloginerror, setDeviceloginerror] = useState("");
    const [AllResellers, setAllResellers] = useState([]);
    const [repairdetailstring, setRepairDetailString] = useState(null);
    const [showOtherRelationshipmanager, setshowOtherRelationshipmanager] = useState(0);
    const [showOtherLocationmanager, setshowOtherLocationmanager] = useState(0);
    const [showOtherDrivermanager, setshowOtherDrivermanager] = useState(0);
    const [contacts, setContacts] = useState([]);
    const [allBuilding, setallbuilding] = useState([]);
    const statusOptions = [
        { id: "0", label: "Pending" },
        { id: "1", label: "Approved" },
        { id: "2", label: "Denied" },
    ];
    const [buildingNetSuiteIds, setBuildingNetSuiteIds] = useState([]);
    const [customPricePartsArray, setCustomPricePartsArray] = useState([]);
    const [allParts, setAllPartsData] = useState({
        data: [],
        loader: false,
        showSuggestionBox: false,
        editPartId: null,
        searchString: "",
        originalEditPrices: null
    });
    const [SchoolNameHeader, setSchoolNameHeader] = useState('');
    const [showPriceDelModal, setShowPriceDelModal] = useState(false);

    useEffect(() => {
        ApiGetCall("/resellers/members/staff").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.msg?.length != 0) {
                    const sortedResellers = responseRs.msg.sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );
                    setAllResellers(sortedResellers);
                } else {
                    setAllResellers([]);
                }
            }
        });
        getpostalcodes(setallstate);
    }, []);
    useEffect(() => {
        getSchoolProfileInfo();
        if (fromadminorschool == 2) {
            GetCustomSchoolParts();
        }
        getAllBuildings(setallbuilding, adminSchoolId ? adminSchoolId : LogInSchoolID);
    }, [LogInSchoolID, adminSchoolId])

    async function getSchoolProfileInfo() {
        var sId = fromadminorschool == 2 ? adminSchoolId : LogInSchoolID;
        setLoading(true);
        await ApiGetCall(`/schools/profile-info?schoolId=${sId}`, null, true).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setCallHubSpot(responseRs?.callToHubspot);
                setshowOtherRelationshipmanager(
                    responseRs?.schoolProfile?.relation_manager ?
                        responseRs?.schoolProfile?.relation_manager_other_flag : 0
                );
                setshowOtherLocationmanager(
                    responseRs?.schoolProfile?.location_manager ?
                        responseRs?.schoolProfile?.location_manager_other_flag
                        : 0
                );
                setshowOtherDrivermanager(
                    responseRs?.schoolProfile?.driver_contact ?
                        responseRs?.schoolProfile?.driver_other_flag
                        : 0
                );
                setAllPickUpLocations(responseRs?.allBuilding);
                if (responseRs?.schoolProfile?.school_description && responseRs?.schoolProfile?.school_description?.trim() != "") {
                    setInvoiceDescription(responseRs?.schoolProfile?.school_description);
                }
                const buildingNetSuiteData = responseRs?.allBuilding
                    ?.filter(building => building.netsuite_customer_code != null)
                    ?.map(building => ({
                        id: crypto.randomUUID(),
                        buildingId: building.id,
                        netSuiteId: building.netsuite_customer_code,
                        flag: 1,
                        addUpdateFlag: 1
                    }));

                setBuildingNetSuiteIds(buildingNetSuiteData)
                setPostImage({ ...postImage, myFile: responseRs?.logo?.logo_path || "" })
                setMailingAddress(responseRs?.schoolProfile?.mailing_address)
                setMainShippingLocation(responseRs?.schoolProfile?.main_shipping_location)
                setPickupTimingForSchool(responseRs?.schoolProfile?.allow_pickup_schedule || 2);
                setSchoolProfile({
                    ...SchoolProfile,
                    enrollment: responseRs?.schoolProfile?.enrollment,
                    customer: responseRs?.schoolProfile?.customer,
                    pricing: responseRs?.schoolProfile?.default_pricing,
                    domain: responseRs?.schoolProfile?.domain,
                    partsOrder: responseRs?.schoolProfile?.part_order_access,
                    RCS: responseRs?.schoolProfile?.rcs,
                    Document: responseRs?.schoolProfile?.reseller_partnership_document,
                    approvalStatus: responseRs?.schoolProfile?.reseller_partnership_status
                });
                var FedexCompanyName = responseRs?.schoolShippingAddress?.fedex_company_name ?
                    responseRs?.schoolShippingAddress?.fedex_company_name :
                    fromadminorschool == 2 ? schoolname :
                        UserData.schoolname;
                setShippingDetails({
                    ...shippingDetails, fedex_company_name: FedexCompanyName,
                    Phoneno: responseRs?.schoolShippingAddress?.phone_num, Street1: responseRs?.schoolShippingAddress?.street_line,
                    Street2: responseRs?.schoolShippingAddress?.street_line2, city: responseRs?.schoolShippingAddress?.city,
                    state: responseRs?.schoolShippingAddress?.state_or_province_code, postalcode: responseRs?.schoolShippingAddress?.postal_code,
                    shippingextension: responseRs?.schoolShippingAddress?.phone_num_extension,
                    pickuplocations: (responseRs?.schoolProfile?.pickup_location_id || []).map(String),
                });
                setSchoolNameHeader(responseRs?.schoolDetails?.name);
                const typeMap = {
                    1: "Secondary",
                    2: "Repair",
                    3: "Billing"
                };
                responseRs?.schoolProfile?.other_contact_details?.map((item) => {
                    setContacts((prevState) => [
                        ...prevState,
                        {
                            id: item.id,
                            type: typeMap[item?.contact_type],
                            typeId: parseInt(item?.contact_type),
                            email: item?.user ? item?.user?.email : item?.email,
                            firstname: item?.user ? item?.user?.first_name : item?.first_name,
                            lastname: item?.user ? item?.user?.last_name : item?.last_name,
                            jobtitle: item?.user ? item?.user?.job_title : item?.job_title,
                            phonenumber: item?.user ? item?.user?.phone_number : item?.phone_number,
                            contactextension: item?.user?.phone_number_ext,
                            phonetype: item?.user ? item?.user?.phone_type : item?.phone_type,
                            method_of_contact: item?.contact_method?.split(","),
                            accesstype: item?.user ? item?.user?.access_type : null,
                            contact_id: item?.contact_id,
                            isNew: false,
                            AddDeleteFlag: 1
                        }
                    ])
                })
                setBillingDetails({
                    ...billingDetails,
                    customerid: responseRs?.schoolProfile?.customer_id || "",
                    accountcredit: responseRs?.schoolProfile?.billing_account_credit,
                    accountcreditusage: (responseRs?.schoolProfile?.billing_account_credit_usage_array || []).map(String),
                    accountcreditusagenotes: responseRs?.schoolProfile?.billing_account_credit_note || "",
                    discoutpricing: responseRs?.schoolProfile?.special_discount,
                    customerid: responseRs?.schoolProfile?.customer_id || "",
                    UseSecondaryPricing: responseRs?.schoolProfile?.use_secondary_pricing || 2
                });

                const matchingStaff = responseRs?.allStaffEmails.find(staff => staff?.email == responseRs?.admin?.email);
                if (responseRs?.schoolProfile?.main_contact) {
                    setContactInformation({
                        ...contactInformation,
                        email: responseRs?.schoolProfile?.main_contact?.email,
                        firstname: responseRs?.schoolProfile?.main_contact?.first_name,
                        lastname: responseRs?.schoolProfile?.main_contact?.last_name,
                        jobtitle: responseRs?.schoolProfile?.main_contact?.job_title,
                        phonenumber: responseRs?.schoolProfile?.main_contact?.phone_number,
                        phonetype: responseRs?.schoolProfile?.main_contact?.phone_type,
                        contactextension: responseRs?.schoolProfile?.main_contact?.phone_number_ext,
                        methodOfContact: (responseRs?.schoolProfile?.method_of_contact_main_array || []).map(String)
                    });
                } else {
                    setContactInformation({
                        ...contactInformation,
                        email: matchingStaff?.email,
                        firstname: matchingStaff?.first_name,
                        lastname: matchingStaff?.last_name,
                        jobtitle: matchingStaff?.job_title,
                        phonenumber: matchingStaff?.phone_number,
                        phonetype: matchingStaff?.phone_type,
                        contactextension: matchingStaff?.phone_number_ext
                    });
                }
                setK12TechData({
                    ...k12TechData, relationShipManager: responseRs?.schoolProfile?.relation_manager?.id || 0,
                    locationManager: responseRs?.schoolProfile?.location_manager?.id || 0,
                    driver: responseRs?.schoolProfile?.driver_contact?.id || 0, startDate: responseRs?.schoolProfile?.k12_team_start_date,
                    relationShipManagerEmail: responseRs?.schoolProfile?.relation_manager?.email, relationShipManagerContact: responseRs?.schoolProfile?.relation_manager?.phone_number,
                    LocationManagerContact: responseRs?.schoolProfile?.location_manager?.phone_number, LocationManagerEmail: responseRs?.schoolProfile?.location_manager?.email,
                    partnership: responseRs?.schoolProfile?.vendor_id, driverEmail: responseRs?.schoolProfile?.driver_contact?.email, driverContact: responseRs?.schoolProfile?.driver_contact?.phone_number
                });
                if (responseRs?.schoolProfile?.repair_coverage_details?.length > 0) {
                    const aspRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 1) // Filter ASP data
                        .map(item => ({
                            deviceType: item.device_type || 0,
                            deviceModel: item.device_model || "",
                            coverageType: item.coverage_type || "",
                            startDate: item.start_date || "",
                            endDate: item.end_date || "",
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));

                    const adpRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 3) // Filter ADP data (all other types)
                        .map(item => ({
                            deviceType: item.device_type || 0,
                            deviceModel: item.device_model || "",
                            startDate: item.start_date || "",
                            endDate: item.end_date || "",
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));

                    const adhocRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 2) // Filter ADP data (all other types)
                        .map(item => ({
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));
                    const coverageRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 4) // Filter ADP data (all other types)
                        .map(item => ({
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));

                    setRepairCoverageData({
                        ...repairCoverageData, adhoc_carted: adhocRows[0]?.carted, adhoc_cases: adhocRows[0]?.cases, adhoc_screen: adhocRows[0]?.screen, parental_carted: coverageRows[0]?.carted, parental_cases: coverageRows[0]?.cases, parental_screen: coverageRows[0]?.screen,
                        adhoc_id: adhocRows[0]?.id, parental_id: coverageRows[0]?.id
                    })
                    if (aspRows.length == 0) {
                        setASProws([{ deviceType: 0, deviceModel: "", coverageType: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                    } else {
                        setASProws([...aspRows]);
                    }

                    if (adpRows.length == 0) {
                        setADProws([{ deviceType: 0, deviceModel: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                    } else {
                        setADProws([...adpRows]);
                    }
                } else {
                    setASProws([{ deviceType: 0, deviceModel: "", coverageType: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                    setADProws([{ deviceType: 0, deviceModel: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                }

                setRepairDetails({
                    ...repairDetails,
                    schoolclosetickets: responseRs?.schoolProfile?.school_closes_ticket || 2,
                    quotingNeeded: responseRs?.schoolProfile?.needs_quoted,
                    minRepairGrade: responseRs?.schoolProfile?.minimum_repair_grade,
                    repairPriceTier: responseRs?.schoolProfile?.repair_price_tier,
                    routeDay: responseRs?.schoolProfile?.route_day,
                    routeFrequency: responseRs?.schoolProfile?.route_frequency,
                    repairNotes: responseRs?.schoolProfile?.repair_notes,
                    repairCoverage: responseRs?.schoolProfile ? Array.from(new Set([
                        ...(responseRs?.schoolProfile?.repair_coverage_array || []),
                        ...(responseRs?.schoolProfile?.repair_coverage_details?.map(item => item.type) || [])
                    ].map(String))) : [],
                    uncovereddevice: responseRs?.schoolProfile?.uncover_device_repair_actions,
                    cosmeticDamageRepaird: responseRs?.schoolProfile?.cosmetic_damage_repaired,
                    selectedDamageRepaird: (responseRs?.schoolProfile?.cosmetic_damage_repaired_options_array || []).map(String),
                    cosmeticdamageNotes: responseRs?.schoolProfile?.cosmetic_damage_notes,
                    deductible: responseRs?.schoolProfile?.deductible,
                    deductibleNotes: responseRs?.schoolProfile?.deductible_notes,
                    uncovereddeviceNotes: responseRs?.schoolProfile?.uncover_device_repair_note,
                    repairpricetiernotes: responseRs?.schoolProfile?.repair_price_tier_notes,
                    additionalAssetNotes: responseRs?.schoolProfile?.additional_asset_management_note,
                });
                setLoanerAsset({
                    ...loanerAsset,
                    countofLoanerDevice: responseRs?.schoolProfile?.loaner_device_ratio,
                    additionalAssets: responseRs?.schoolProfile ?
                        (responseRs?.schoolProfile?.additional_asset_management_array || []).map(String) : []
                })
                const SortedEmails = responseRs?.allStaffEmails.sort((a, b) => a.email.localeCompare(b.email))
                setStaffEmails(SortedEmails)
                setAllRelationShipManager(responseRs?.allRelationShipManager)
                setAllLocationManager(responseRs?.allLocationManager)
                setAllDriver(responseRs?.allDriver)
                setDeviceInformation({
                    ...deviceInformation, weeklyrepairs: responseRs?.weeklyRepairsCount,
                    devicesindistrict: responseRs?.schoolProfile ? (responseRs?.schoolProfile?.devices_in_district_array || []).map(String) : []
                })
                const deviceTypeMap = {
                    1: "Chromebook",
                    2: "Windows",
                    3: "iPad",
                    4: "MacBook"
                };
                const groupedLogins = responseRs?.schoolProfile?.device_credential_detail?.reduce((acc, item) => {
                    const deviceName = deviceTypeMap[item.device_type] || "Unknown";
                    let existingDevice = acc.find(d => d.device === deviceName);

                    if (existingDevice) {
                        existingDevice.credentials.push({ id: item.id, uniqueId: item.id, username: item.user_name, password: item.password, flag: 1 });
                    } else {
                        acc.push({
                            id: item.device_type,
                            device: deviceName,
                            uniqueId: item.id,
                            credentials: [{ id: item.id, username: item.user_name, password: item.password, flag: 1 }]
                        });
                    }

                    return acc;
                }, []);

                setLogins(responseRs?.schoolProfile?.device_credential_detail?.length > 0 ? groupedLogins : [
                    { id: 0, device: "Chromebook", credentials: [{ id: 0, username: "", password: "", flag: 0 }] }
                ]);
                if (responseRs?.schoolProfile?.repair_cap_details?.length > 0) {
                    const capRows = responseRs.schoolProfile.repair_cap_details.map((item) => ({
                        deviceType: item.device_type || "",
                        capAmount: item.repair_cap || "",
                        capexceeding: item.exceeding_cap_handling || "",
                        id: item.id || 0,
                        notes: item.note || "",
                        flag: 2
                    }));
                    setRepairCapRows([...capRows]);
                } else {
                    setRepairCapRows([{ deviceType: "", capAmount: "", capexceeding: "", id: 0, notes: "", flag: 1 }]);
                }

            }
        });
    }
    const handleDeviceDistrictCheckboxChange = (e, id) => {
        setDeviceInformation((prevState) => {
            const existingUsage = prevState?.devicesindistrict ?? [];
            const isChecked = e.target.checked;
            const idString = String(id); // Convert ID to string
            return {
                ...prevState,
                devicesindistrict: isChecked
                    ? [...existingUsage.map(String), idString] // Convert all existing values to strings
                    : existingUsage.filter((item) => String(item) !== idString) // Ensure filtering works correctly
            };
        });
    };
    const handleContactChange = (id, field, value) => {
        setContacts((prev) =>
            prev.map((c) => (c.id === id ? { ...c, [field]: value } : c))
        );
    };
    const handleCosmeticDamageCheckboxChange = (e, id) => {
        createStringForRepairDetails('damage_repaired_options')
        setRepairDetails((prevState) => {
            const existingUsage = prevState?.selectedDamageRepaird ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);

            return {
                ...prevState,
                selectedDamageRepaird: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleRepairCoverageCheckboxChange = (e, id) => {
        setRepairDetails((prevState) => {
            const existingUsage = prevState?.repairCoverage ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                repairCoverage: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
        createStringForRepairDetails('repair_coverage');
    };
    const handleAdditionalAssetManagementCheckboxChange = (e, id) => {
        createStringForRepairDetails('asset_management')
        setLoanerAsset((prevState) => {
            const existingUsage = prevState?.additionalAssets ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                additionalAssets: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleASPRepairCoverageChange = (index, field, value) => {
        const newRows = [...ASProws];
        newRows[index][field] = value;
        setASProws(newRows);
    };
    const handleAddNewASPRows = () => {
        const lastRow = ASProws[ASProws.length - 1];
        const isRowValid = lastRow.deviceType != 0 &&
            lastRow.carted != 0 &&
            lastRow.cases != 0 &&
            lastRow.screen != 0 &&
            lastRow.deviceModel &&
            lastRow.coverageType &&
            lastRow.startDate &&
            lastRow.endDate;

        if (isRowValid) {
            setASProws([
                ...ASProws,
                {
                    deviceType: 0,
                    deviceModel: "",
                    coverageType: "",
                    startDate: "",
                    endDate: "",
                    carted: 0,
                    cases: 0,
                    screen: 0,
                },
            ]);
            setAsperror(""); // Clear any previous error
        } else {
            setAsperror(ASProws.length - 1); // Set error index instead of message
        }
    };

    const handleADPRepairCoverageChange = (index, field, value) => {
        const newRows = [...ADProws];
        newRows[index][field] = value;
        setADProws(newRows);
    };
    const handleAddNewADPRows = () => {
        const lastRow = ADProws[ADProws.length - 1];
        const isRowValid = lastRow.deviceType != 0 &&
            lastRow.carted != 0 &&
            lastRow.cases != 0 &&
            lastRow.screen != 0 &&
            lastRow.deviceModel &&
            lastRow.startDate &&
            lastRow.endDate;

        if (isRowValid) {
            setADProws([
                ...ADProws,
                {
                    deviceType: 0,
                    deviceModel: "",
                    startDate: "",
                    endDate: "",
                    carted: 0,
                    cases: 0,
                    screen: 0,
                },
            ]);
            setAdperror(""); // Clear any previous error
        } else {
            setAdperror(ADProws.length - 1); // Set error index instead of message
        }

    }
    const addLogin = () => {
        setDeviceloginerror("")
        // Check if any existing login is incomplete
        for (let login of logins) {
            if (login.id === 0 && !login.deleteAllFlag) {
                setDeviceloginerror("Please select a device for all existing entries.");
                return;
            }
            for (let cred of login.credentials) {
                if (cred.flag !== 2 && (!cred?.username?.trim() || !cred?.password?.trim())) {
                    setDeviceloginerror("Please fill out all username and password fields.");
                    return;
                }
            }
        }

        // Add new login row
        const newLogin = {
            uniqueId: Date.now(), // or use a UUID lib
            id: 0,
            device: "",
            credentials: [{
                id: 0, // You may want to generate a unique ID here
                username: '',
                password: '',
                flag: 0
            }]
        };

        setLogins([...logins, newLogin]);
    };

    const updateLogin = (uniqueId, field, value) => {
        setLogins(logins.map(login =>
            login.uniqueId === uniqueId ? { ...login, [field]: value } : login
        ));
        createStringForRepairDetails('device_login');
    };

    const addCredential = (loginUniqueId) => {
        const newCredential = {
            id: Date.now() + Math.random(), // unique ID
            uniqueId: Date.now(),
            username: '',
            password: '',
            showPassword: false,
            flag: 0
        };
        setLogins(prev =>
            prev.map(login =>
                login.uniqueId === loginUniqueId
                    ? { ...login, credentials: [...login.credentials, newCredential] }
                    : login
            )
        );
        createStringForRepairDetails('device_login');
    };
    const updateCredential = (loginUniqueId, credId, field, value) => {
        setLogins(logins.map(login =>
            login.uniqueId == loginUniqueId
                ? { ...login, credentials: login.credentials.map(cred => cred.id == credId ? { ...cred, [field]: value } : cred) }
                : login
        ));
        createStringForRepairDetails('device_login');
    };
    const removeCredential = (loginUniqueId, credId) => {
        setLogins(prev =>
            prev.map(login =>
                login.uniqueId === loginUniqueId
                    ? {
                        ...login,
                        credentials: credId === 0
                            ? login.credentials.filter(cred => cred.id !== credId)
                            : login.credentials.map(cred =>
                                cred.id === credId ? { ...cred, flag: 2 } : cred
                            )
                    }
                    : login
            )
        );
        createStringForRepairDetails('device_login');
    };
    const removeAllCredentials = (uniqueId) => {
        const updatedLogins = [...logins];

        // Find and update the target login
        const loginIndex = updatedLogins.findIndex(login => login.uniqueId === uniqueId);
        if (loginIndex >= 0) {
            updatedLogins[loginIndex].credentials.forEach(cred => {
                cred.flag = 2;
            });

            // Set deleteAll flag based on credentials status
            updatedLogins[loginIndex].deleteAllFlag = true;

            // Update the state
            setLogins(updatedLogins);
        }
    };

    const togglePasswordVisibility = (loginUniqueId, credId) => {
        setLogins((prevLogins) =>
            prevLogins.map((login) =>
                login.uniqueId === loginUniqueId
                    ? {
                        ...login,
                        credentials: login.credentials.map((cred) =>
                            cred.id === credId ? { ...cred, showPassword: !cred.showPassword } : cred
                        ),
                    }
                    : login
            )
        );
    };
    const validateRequiredFieldsInDiv = (divId, customValidator = null) => {
        const container = document.getElementById(divId);
        if (!container) return false;

        let isValid = true;
        let firstErrorField = null;

        container.querySelectorAll('[required]').forEach((field) => {
            field.classList.remove('is-invalid');
        });

        container.querySelectorAll('[required]').forEach((field) => {
            if (!field.value.trim()) {
                field.classList.add('is-invalid');
                if (!firstErrorField) firstErrorField = field;
                isValid = false;
            }
        });

        if (customValidator) {
            const { success, firstErrorSelector } = customValidator();
            if (!success) {
                isValid = false;
                const field = document.querySelector(firstErrorSelector);
                if (field) {
                    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    field.focus();
                    return false;
                }
            }
        }

        if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorField.focus();
            return false;
        }

        return true;
    };

    const validateMainContactExtras = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateDeviceDetails = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateRepairDetails = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateShippingExtras = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        if (fromadminorschool != 2) {
            if (mainshippinglocation == 0) {
                if (!shippingDetails?.pickuplocations || shippingDetails?.pickuplocations?.length === 0) {
                    errors.pickuplocationError = '*required';
                    firstErrorSelector = '[name="pickuplocation"]';
                    success = false;
                }
            }
        }
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };

    const saveAccountDetailsJson = async () => {
        var base64File = null;
        try {
            base64File = await convertToBase64(SchoolProfile?.Document);
        } catch (error) {
            log.error("Error converting file to base64:", error);
        }
        const raw = JSON.stringify({
            enrollment: SchoolProfile.enrollment || null,
            customer: SchoolProfile.customer || null,
            partnerShipId: k12TechData.partnership || null,
            schoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            document: base64File,
            partnerShipApprovalStatus: SchoolProfile?.approvalStatus,
            netsuiteCodeProfile: 1
        });
        return raw;
    };
    const saveMainContactDivJson = () => {
        var mainContactjson = {
            email: contactInformation.email || null,
            otherEmail: contactInformation.otheremail || null,
            accessType: contactInformation.accesstype || null,
            firstName: contactInformation.firstname || null,
            lastName: contactInformation.lastname || null,
            jobTitle: contactInformation.jobtitle || null,
            phoneNumber: contactInformation.phonenumber || null,
            phoneType: contactInformation.phonetype || null,
            contactExtension: contactInformation.contactextension || null,
            methodOfContact: contactInformation.methodOfContact || null,
        }
        const otherContacts = (deletePopup.show ? [deletePopup.item] : contacts?.filter(item => !(item.isNew && item.AddDeleteFlag == 2)))
            ?.map((item) => ({
                email: item.email || null,
                otherEmail: item.otheremail || null,
                accessType: item.accesstype || null,
                firstName: item.firstname || null,
                lastName: item.lastname || null,
                jobTitle: item.jobtitle || null,
                phoneNumber: item.phonenumber || null,
                phoneType: item.phonetype || null,
                contactExtension: item.contactextension || null,
                methodOfContact: item.method_of_contact || null,
                typeId: item.typeId,
                addDeleteFlag: deletePopup.show ? 2 : item.AddDeleteFlag
            }));

        const raw = JSON.stringify({
            otherContacts,
            schoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            ...(!deletePopup.show && {
                mainContacts: mainContactjson,
                startDate: k12TechData.startDate ? MMDDYYYY(k12TechData.startDate) : null,
                relationshipManagerId: k12TechData.relationShipManager || null,
                locationManagerId: k12TechData.locationManager || null,
                driverId: k12TechData.driver || null
            })
        });
        return raw;
    };
    const saveShippingDetailsJson = () => {
        const shippingAddress = {
            fedexCompanyName: shippingDetails.fedex_company_name || null,
            phoneNumber: shippingDetails.Phoneno || null,
            shippingExtension: shippingDetails.shippingextension || null,
            streetLine1: shippingDetails.Street1 || null,
            streetLine2: shippingDetails.Street2 || null,
            city: shippingDetails.city || null,
            state: shippingDetails.state || null,
            postalCode: shippingDetails.postalcode || null,
            countryCode: "US",
        };
        const raw = JSON.stringify({
            pickUpLocationsId: shippingDetails.pickuplocations || null,
            buildingName: shippingDetails?.pickuplocations?.includes("0") ? shippingDetails.buildingname : null,
            shippingAddresses: shippingAddress,
            mailingAddress: mailingaddress,
            mainShippingLocation: mainshippinglocation,
            schoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            allowPickupSchedule: pickupTimingForSchool
        });
        return raw;
    };
    const saveBillingDetailsJson = () => {
        const raw = JSON.stringify({
            accountCredit: billingDetails.accountcredit || null,
            accountCreditUsage: billingDetails.accountcreditusage || null,
            accountCreditUsageNotes: billingDetails.accountcreditusagenotes || null,
            specialDiscountsPricings: billingDetails.discoutpricing || null,
            pricings: SchoolProfile.pricing || null,
            schoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            useSecondaryPricing: billingDetails.UseSecondaryPricing || 2,
            userId: LogInUserID,
        });
        return raw;
    };
    const saveDeviceDetailsDivJson = () => {
        const raw = JSON.stringify({
            schoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            deviceInDistrict: deviceInformation.devicesindistrict || null,
            loanerDeviceRatio: loanerAsset.countofLoanerDevice || null,
        });
        return raw;
    }
    const saveRepairDetailsDivJson = () => {
        var repairCoverageArray = [];
        {
            if (repairDetails?.repairCoverage?.includes("1")) {
                ASProws?.forEach((item) => {
                    var vjson = {
                        deviceType: item.deviceType || null,
                        deviceModel: item.deviceModel || null,
                        coverageType: item.coverageType || null,
                        startDate: item.startDate || null,
                        endDate: item.endDate || null,
                        carted: item.carted || null,
                        cases: item.cases || null,
                        screen: item.screen || null,
                        uuid: 1,
                        flag: item.id || 0
                    };
                    repairCoverageArray.push(vjson);
                });
            }
            if (repairDetails?.repairCoverage?.includes("3")) {
                ADProws?.forEach((item) => {
                    var vjson = {
                        deviceType: item.deviceType || null,
                        deviceModel: item.deviceModel || null,
                        startDate: item.startDate || null,
                        endDate: item.endDate || null,
                        carted: item.carted || null,
                        cases: item.cases || null,
                        screen: item.screen || null,
                        uuid: 3,
                        flag: item.id || 0
                    };
                    repairCoverageArray.push(vjson);
                });
            }

            if (repairDetails?.repairCoverage?.includes("2")) {
                repairCoverageArray.push({
                    deviceType: null,
                    deviceModel: null,
                    coverageType: null,
                    startDate: null,
                    endDate: null,
                    carted: repairCoverageData.adhoc_carted || 0,
                    cases: repairCoverageData.adhoc_cases || 0,
                    screen: repairCoverageData.adhoc_screen || 0,
                    uuid: 2,
                    flag: repairCoverageData.adhoc_id || 0
                });
            }

            if (repairDetails?.repairCoverage?.includes("4")) {
                repairCoverageArray.push({
                    deviceType: null,
                    deviceModel: null,
                    coverageType: null,
                    startDate: null,
                    endDate: null,
                    carted: repairCoverageData.parental_carted || 0,
                    cases: repairCoverageData.parental_cases || 0,
                    screen: repairCoverageData.parental_screen || 0,
                    uuid: 4,
                    flag: repairCoverageData.parental_id || 0
                });
            }

        }
        const hasInvalidCred = logins?.some(login =>
            login.id != 0 && login.credentials?.some(cred => cred.flag !== 2 && (!cred.username || !cred.password))
        );

        if (hasInvalidCred) {
            setDeviceloginerror("Please fill out all username and password fields.");
            return false;
        }
        const multiDeviceLogin = logins?.filter(r => r.id != 0)?.map(login => ({
            deviceId: login.id,
            credentials: login.credentials
                .filter(cred => cred.username !== "")
                .map(cred => ({
                    userName: cred.username,
                    password: cred.password,
                    flag: cred.flag,
                    id: cred.flag === 0 ? 0 : cred.id
                }))
        }));


        const multiDeviceLoginIds = logins?.filter(r => r.id != 0)?.map(login => login.id);
        var repairCapArray = [];
        repairCapRows?.forEach((cap) => {
            var vjson = {
                uuid: cap.id,
                deviceType: cap.deviceType,
                repairCap: cap.capAmount,
                capExceeding: cap.capexceeding,
                exceedingNotes: cap.notes || null,
                flag: cap.flag,
            };
            if (cap.deviceType != "" || cap.capAmount != "" || cap.capexceeding != "" || cap.notes != "") {
                repairCapArray.push(vjson);
            }
        });
        const repairCapIds = repairCapRows.map(cap => cap.id);
        const raw = JSON.stringify({
            schoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            weeklyRepairs: deviceInformation.weeklyrepairs,
            repairCapIds: repairCapArray.length > 0 ? repairCapIds : null,
            repairCaps: repairCapArray || null,
            repairNotes: repairDetails.repairNotes || null,
            minimumRepairGrade: repairDetails.minRepairGrade || null,
            repairPriceTier: repairDetails.repairPriceTier || null,
            repairPriceTierNotes: repairDetails.repairpricetiernotes || null,
            quotingNeeded: repairDetails.quotingNeeded || null,
            deductible: repairDetails.deductible || null,
            deductibleNotes: repairDetails.deductibleNotes || null,
            cosmeticDamageRepaired: repairDetails.cosmeticDamageRepaird || null,
            cosmeticDamageRepairedOptions: repairDetails.selectedDamageRepaird || null,
            cosmeticDamageNotes: repairDetails.cosmeticdamageNotes || null,
            routeDay: repairDetails.routeDay || null,
            routeFrequencies: repairDetails.routeFrequency || null,
            uncoverDeviceRepairActions: repairDetails.uncovereddevice || null,
            uncoverDeviceRepairNotes: repairDetails.uncovereddeviceNotes || null,
            additionalAssetManagementSystems: loanerAsset.additionalAssets || null,
            additionalAssetManagementNotes: repairDetails.additionalAssetNotes || null,
            multiDeviceLogin: multiDeviceLogin,
            multiDeviceLoginSelected: multiDeviceLoginIds,
            repairCoverageID: repairDetails.repairCoverage,
            repairCoverages: repairCoverageArray,
            repairSectionAddUpdateFlag: 1,
            repairDetailString: repairdetailstring,
            schoolClosesTicket: repairDetails.schoolclosetickets || 0,
            partOrderAccess: SchoolProfile.partsOrder,
            rcs: SchoolProfile.RCS,
        });
        return raw;
    }
    const handleSaveSection = async (sectionName, validateExtras) => {
        let firstErrorField = null;
        var isFormValid = CheckValidation({ formID: sectionName });
        if (validateExtras) {
            const isValid = validateRequiredFieldsInDiv(sectionName, validateExtras);
            if (!isValid) return;
        }
        const accountDetailsDiv = document.getElementById(sectionName);
        const requiredFields = accountDetailsDiv.querySelectorAll('[required]');
        requiredFields.forEach(field => {
            if (!field.value.trim()) { // Check if field is empty
                field.classList.add('is-invalid'); // Add Bootstrap's invalid class (or your own styling)
                if (!firstErrorField) {
                    firstErrorField = field;
                }
            } else {
                field.classList.remove('is-invalid'); // Remove error styling if field is filled
            }
        });

        if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorField.focus();
            return;
        }

        if (!isFormValid) return;
        setLoading(true);
        var vJson;
        switch (sectionName) {
            case 'MainContactDiv':
                vJson = saveMainContactDivJson();
                break;
            case 'AccountDetailsDiv':
                vJson = await saveAccountDetailsJson()
                break;
            case 'ShippingDetailsDiv':
                vJson = saveShippingDetailsJson();
                break;
            case 'BillingDetailsDiv':
                vJson = saveBillingDetailsJson();
                break;
            case 'DeviceDetailsDiv':
                vJson = saveDeviceDetailsDivJson();
                break;
            case 'RepairDetailsDiv':
                vJson = saveRepairDetailsDivJson();
                break;
            default:
                log.warn('Unknown section');
                break;
        }
        if (vJson == false) {
            setLoading(false);
            return;
        }
        setDeviceloginerror("");
        await ApiPostCall("/schools/profile-info/save", vJson).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={deletePopup.show ? "Contact removed Successfully." : "Service Profile Updated Successfully."} />);
                    if (fromadminorschool != 2) {
                        if (postImage.myFile == "") {
                            setUserData(prevUserData => ({ ...prevUserData, schoollogo: left_menu_white_logo }));
                        } else {
                            setUserData(prevUserData => ({ ...prevUserData, schoollogo: postImage.myFile || "" }));
                        }
                    }
                    setContacts([]);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);

                        getSchoolProfileInfo();
                        if (callHubspot) {
                            var raw = JSON.stringify({
                                "sid": fromadminorschool == 2 ? adminSchoolId || null : stateRedux.authData.SchoolId || null,
                                "uid": stateRedux.authData.csvUserID || null,
                                "flag": 2
                            });

                            ApiPostCall("/hubspot/accounts/sync", raw)
                        }
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const toggleKey = (key) => {
        if (activeKeys.includes(key)) {
            setActiveKeys(activeKeys.filter(k => k !== key));
        } else {
            setActiveKeys([...activeKeys, key]);
        }
    };
    const handleRepairCapChange = (index, field, value) => {
        const updatedRows = [...repairCapRows];
        updatedRows[index][field] = value;
        setRepairCapRows(updatedRows);
        createStringForRepairDetails('repair_cap');
    };
    const handleAddRepairCapRow = () => {
        setRepairCapRows([...repairCapRows, { deviceType: "", capAmount: "", capexceeding: "", id: 0, notes: "", flag: 1 }]);
    };
    const handleRemoveRepairCapRow = (index) => {
        setRepairCapRows((prevRows) => {
            const updatedRows = [...prevRows];
            const row = updatedRows[index];

            if (row.id != 0) {
                updatedRows[index] = { ...row, flag: 3 };
            } else {
                updatedRows.splice(index, 1);
            }

            return updatedRows;
        });
    };
    const popover = (
        <Popover id="popover-basic" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Header as="h3">Contact Information</Popover.Header>
            <Popover.Body>
                <ul className="text-justify">
                    <li className="pt-1"><label className="fw-600">Email: </label> {k12TechData?.LocationManagerEmail || '-'}</li>
                    <li className="pt-1"><label className="fw-600">Contact Number: </label> {k12TechData?.LocationManagerContact || '-'}</li>
                </ul>
            </Popover.Body>
        </Popover>
    );
    const popoverRelationship = (
        <Popover id="popover-basic" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Header as="h3">Contact Information</Popover.Header>
            <Popover.Body>
                <ul className="text-justify">
                    <li className="pt-1"><label className="fw-600">Email: </label> {k12TechData?.relationShipManagerEmail || '-'}</li>
                    <li className="pt-1"><label className="fw-600">Contact Number: </label> {k12TechData?.relationShipManagerContact || '-'}</li>
                </ul>
            </Popover.Body>
        </Popover>
    );
    const popoverDriver = (
        <Popover id="popover-basic" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Header as="h3">Contact Information</Popover.Header>
            <Popover.Body>
                <ul className="text-justify">
                    <li className="pt-1"><label className="fw-600">Email: </label> {k12TechData?.driverEmail || '-'}</li>
                    <li className="pt-1"><label className="fw-600">Contact Number: </label> {k12TechData?.driverContact || '-'}</li>
                </ul>
            </Popover.Body>
        </Popover>
    );
    const handleToggle = (nextShow) => {
        setShowPopover(nextShow);
    };
    const handleToggleRelationship = (nextShow) => {
        setRelationshipshowPopover(nextShow);
    };
    const handleToggleDriver = (nextShow) => {
        setdriverhowPopover(nextShow);
    };
    const handleToggleAddress = (nextShow) => {
        setShowAddressPopover(nextShow);
    };

    const createStringForRepairDetails = (key) => {
        typewatch(() => {
            setRepairDetailString(prev => {
                const safePrev = prev || ''; // fallback to empty string
                const keysArray = safePrev.split('~').filter(k => k);

                if (!keysArray.includes(key)) {
                    keysArray.push(key);
                    return keysArray.join('~');
                }
                return safePrev; // return unchanged if key exists
            });
        }, 1000);
    };

    const handleSaveInvoiceDescription = async () => {
        const invalidRow = buildingNetSuiteIds?.find(item => item.buildingId === "0");

        if (invalidRow) {
            setNewAlerts(<AlertsComp show={true} variant="danger" msg={'Please select a building for all NetSuite mappings before saving.'} />);
            setTimeout(() => { setNewAlerts(<AlertsComp show={false} />) }, 2000);
            return;
        }

        const otherCustomerIds = buildingNetSuiteIds?.map(item => ({
            buildingId: item.buildingId,
            netSuiteCustomerCode: item.netSuiteId,
            addUpdateDeleteFlag: item.flag
        }));

        var raw = JSON.stringify({
            schoolId: adminSchoolId,
            userId: LogInUserID,
            description: invoiceDescription,
            customerCode: billingDetails.customerid,
            otherCustomerIds: otherCustomerIds
        });

        setLoading(true);
        await ApiPostCall("/tickets/set-description", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'NetSuite and Pricing Information Updated Successfully.'} />);
                    if (fromadminorschool != 2) {
                        if (postImage.myFile == "") {
                            setUserData(prevUserData => ({ ...prevUserData, schoollogo: left_menu_white_logo }));
                        } else {
                            setUserData(prevUserData => ({ ...prevUserData, schoollogo: postImage.myFile || "" }));
                        }
                    }
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        getSchoolProfileInfo();
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    function ShowFileName() {
        const fileInput = ImportDevicesFile.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid } = ValidateFile(files, { allowedType: "pdf", maxSizeMB: 5 });
        if (!isFileValid) {
            setSchoolProfile({ ...SchoolProfile, FileName: 'You can only upload pdf files', Document: '' });
            fileInput.value = "";
            return;
        }
        setSchoolProfile({ ...SchoolProfile, FileName: filename, Document: files });
    }
    const openPDFInNewTab = (doc) => {
        if (doc instanceof File) {
            // Handle local file
            const fileURL = URL.createObjectURL(doc);
            window.open(fileURL, '_blank');
        } else if (typeof doc === "string" && doc !== "") {
            // Handle CDN file path
            ApiGetCDNData("/" + doc, StateData?.Schoolnumber).then((blob) => {
                try {
                    const url = URL.createObjectURL(blob);
                    if (url) window.open(url, '_blank');
                } catch (err) {
                    log.error(err)
                }
            });
        }
    };

    const AddNewNetsuiteRow = () => {
        setBuildingNetSuiteIds([...buildingNetSuiteIds, { id: crypto.randomUUID(), buildingId: "0", netSuiteId: "", addUpdateFlag: 0, flag: 1 }]);
    }

    const AddCustomPriceParts = (isCheckboxState, partDetails) => {
        setCustomPricePartsArray(prev => {
            if (isCheckboxState) {
                if (prev.some(p => p.partId === partDetails.id)) return prev;
                return [
                    ...prev,
                    {
                        id: crypto.randomUUID(),
                        partId: partDetails.id,
                        partName: partDetails.title,
                        newPrice: "0",
                        originalPrice: partDetails.variant_price,
                        flag: 1,
                        isCheckboxState: isCheckboxState
                    }
                ];
            } else {
                return prev.filter(p => p.partId !== partDetails.id);
            }
        });
    }

    const HideShowSuggestionBox = (showHideFlag) => {
        setAllPartsData(prev => ({ ...prev, showSuggestionBox: showHideFlag, data: [], loader: false }));
    }

    async function GetRepairParts(searchString) {
        if (searchString?.trim() == "" || searchString == undefined) {
            setAllPartsData(prev => ({ ...prev, loader: false }));
            searchString = null;
        } else {
            searchString = searchString?.trim() || null;
        }
        setAllPartsData(prev => ({ ...prev, loader: true, showSuggestionBox: searchString && true }));
        typewatch(async function () {
            await ApiGetCall(`${adminCallNode}/parts/all?search=${searchString}&ticketId=${null}&seeMore=${0}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs.response == "success") {
                        setAllPartsData(prev => ({ ...prev, data: responseRs.msg, loader: false }));
                    } else {
                        setAllPartsData(prev => ({ ...prev, data: [], loader: false }));
                    }
                }
            });
        }, 1000);
    }

    const GetCustomSchoolParts = async (addUpdateDeleteFlag) => {
        setLoading(true);
        await ApiGetCall(`/schools/parts/custom-details?schoolId=${adminSchoolId}`).then((result) => {
            if (result == undefined || result == "") {
                log.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    const partsArray = responseRs?.data
                        ?.filter(partDetail => partDetail?.part?.id != null)
                        ?.map(partDetail => ({
                            id: crypto.randomUUID(),
                            partId: partDetail?.part?.id,
                            partName: partDetail?.part?.title,
                            originalPrice: partDetail?.part?.variant_price,
                            newPrice: partDetail?.custom_price,
                            flag: 2,
                            isCheckboxState: true
                        }));
                    let newParts = [];
                    if (addUpdateDeleteFlag == 2 || addUpdateDeleteFlag == 3) {
                        newParts = customPricePartsArray.filter(part => part.flag == 1);
                    }
                    setCustomPricePartsArray([...partsArray, ...newParts]);
                } else {
                    setCustomPricePartsArray([]);
                }
            }
        })
    }

    const addUpdateDeleteSchoolCustomPart = async (addUpdateDeleteFlag = 1) => {
        const finalPartsArray = customPricePartsArray?.filter(part => part.partId != null)?.filter(part => part.flag == addUpdateDeleteFlag)?.map(part => ({
            partId: part.partId,
            customPrice: part.newPrice || 0,
            flag: part.flag
        }));

        if (finalPartsArray.length == 0) {
            setNewAlerts(<AlertsComp show={true} variant="danger" msg={'No changes to save.'} />);
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />)
            }, 2000);
            return;
        }

        var raw = JSON.stringify({
            schoolId: adminSchoolId,
            loginUserId: LogInUserID,
            parts: finalPartsArray
        });

        setLoading(true);
        await ApiPostCall("/schools/custom-parts/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Custom Price for parts saved successfully!"} />);
                    setTimeout(() => {
                        setLoading(false);
                        setAllPartsData(prev => ({ ...prev, searchString: "" }));
                        if (fromadminorschool == 2) {
                            GetCustomSchoolParts(addUpdateDeleteFlag);
                        }
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    return (
        <div>
            <PageHead heading={`${SchoolNameHeader} ${SchoolNameHeader && '-'} Service Profile`} loading={loading} Alerts={NewAlerts} showsearch={false} />
            <div className="container-fluid px-0 mt-2">
                <div className="GridBox p-2">
                    <div className='greyBox '>

                        {/* main contact information section */}
                        <div>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Technology Department Main Contact </label>
                            </div>
                            <div className="GridBox  p-2 align-items-center parent" id="MainContactDiv" >
                                <ContactsAccordion contacts={contacts} setContacts={setContacts} errors={errors} fromadminorschool={fromadminorschool} staffEmails={staffEmails} methodOfContact={methodOfContact}
                                    contactInformation={contactInformation} setContactInformation={setContactInformation} handleContactChange={handleContactChange} deletePopup={deletePopup} setDeletePopup={setDeletePopup} />

                                <div className='pt-3'>
                                    <div className='col-12  pb-2'>
                                        <label className='schoolprofile-headers'>Your {enterprise_name} Team</label>
                                    </div>
                                    <div className='col-12 px-3'>
                                        <div className='row ' style={{ backgroundColor: fromadminorschool != 2 && "rgb(240, 240, 241)", border: fromadminorschool != 2 && "1px solid rgb(226, 227, 228)", borderRadius: fromadminorschool != 2 && "0.3rem" }}>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Start Date</div>
                                                <CustomReactDatePicker
                                                    selectedDate={k12TechData.startDate ? ymdToDate(k12TechData.startDate) : null}
                                                    onChangeHandler={(date) => setK12TechData({ ...k12TechData, startDate: date ? YYYYMMDD(date) : "" })}
                                                    isDisabled={fromadminorschool != 2}
                                                    placeholderText="MM-DD-YYYY"
                                                />
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3">
                                                <div className='col-12 text-start d-flex font-13  pb-1 new-font-style'>
                                                    <label>Relationship Manager</label>
                                                    {fromadminorschool != 2 &&
                                                        <div className='ps-2'>
                                                            <OverlayTrigger
                                                                trigger="click"
                                                                show={relationshipshowPopover}
                                                                onToggle={handleToggleRelationship}
                                                                overlay={popoverRelationship}
                                                            >
                                                                <a href="#" role="button" onClick={(e) => e.preventDefault()}>
                                                                    <img src="/images/InfoBtn.svg" title="Show Email and Contact Number" className="cursor-pointer" height='16px' />
                                                                </a>
                                                            </OverlayTrigger>
                                                        </div>
                                                    }
                                                </div>
                                                <div className='row pe-2'>
                                                    <div className='col-md-12 pe-0'>
                                                        <select name='relationshipmanager' style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                            disabled={fromadminorschool != 2}
                                                            value={showOtherRelationshipmanager ? "other" : k12TechData.relationShipManager}
                                                            onChange={(e) => {
                                                                if (e.target.value == "other") {
                                                                    setshowOtherRelationshipmanager(true);
                                                                    setK12TechData({ ...k12TechData, relationShipManager: "0" });
                                                                } else {
                                                                    setshowOtherRelationshipmanager(false);
                                                                    setK12TechData({ ...k12TechData, relationShipManager: e.target.value });
                                                                }
                                                            }}>
                                                            <option value="0">Select</option>
                                                            {allRelationShipManager?.filter((item) => item.flag == 1).map((item, i) => {
                                                                return <option key={i} value={item.id}>{item.first_name} {item.last_name} {item.phone_number && `(${item.phone_number})`}</option>
                                                            })}
                                                            <option value="other">Other</option>
                                                        </select>
                                                    </div>
                                                    {showOtherRelationshipmanager == 1 &&
                                                        <div className='col-md-12 pe-0'>
                                                            <select name='relationshipmanager' className='mt-3'
                                                                disabled={fromadminorschool != 2}
                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                value={k12TechData.relationShipManager}
                                                                onChange={(e) => setK12TechData({ ...k12TechData, relationShipManager: e.target.value })}>
                                                                <option value="0">Select</option>
                                                                {allRelationShipManager?.filter((item) => item.flag != 1).map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.first_name} {item.last_name} {item.phone_number && `(${item.phone_number})`}</option>
                                                                })}
                                                            </select>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start d-flex font-13 pb-1 new-font-style'>
                                                    <label> Location Manager</label>
                                                    {fromadminorschool != 2 &&
                                                        <div className='ps-2'>
                                                            <OverlayTrigger
                                                                trigger="click"
                                                                show={showPopover}
                                                                onToggle={handleToggle}
                                                                overlay={popover}
                                                            >
                                                                <a href="#" role="button" onClick={(e) => e.preventDefault()}>
                                                                    <img src="/images/InfoBtn.svg" title="Show Email and Contact Number" className="cursor-pointer" height='16px' />
                                                                </a>
                                                            </OverlayTrigger>
                                                        </div>
                                                    }
                                                </div>
                                                <div className='row pe-2'>
                                                    <div className='col-md-12 pe-0'>
                                                        <select name='locationmanager'
                                                            style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                            disabled={fromadminorschool != 2}
                                                            value={showOtherLocationmanager ? "other" : k12TechData.locationManager}
                                                            onChange={(e) => {
                                                                if (e.target.value == "other") {
                                                                    setshowOtherLocationmanager(true);
                                                                    setK12TechData({ ...k12TechData, locationManager: "0" });
                                                                } else {
                                                                    setshowOtherLocationmanager(false);
                                                                    setK12TechData({ ...k12TechData, locationManager: e.target.value });
                                                                }
                                                            }}>
                                                            <option value="0">Select</option>
                                                            {allLocationManager?.filter((item) => item.flag == 1).map((item, i) => {
                                                                return <option key={i} value={item.id}>{item.first_name} {item.last_name}{item.phone_number && `(${item.phone_number})`}</option>
                                                            })}
                                                            <option value="other">Other</option>

                                                        </select>
                                                    </div>
                                                    {showOtherLocationmanager == 1 &&
                                                        <div className='col-md-12 pe-0'>
                                                            <select name='locationmanager' className='mt-3'
                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                disabled={fromadminorschool != 2}
                                                                value={k12TechData.locationManager}
                                                                onChange={(e) => setK12TechData({ ...k12TechData, locationManager: e.target.value })}>
                                                                <option value="0">Select</option>
                                                                {allLocationManager?.filter((item) => item.flag != 1).map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.first_name} {item.last_name}{item.phone_number && `(${item.phone_number})`}</option>
                                                                })}

                                                            </select>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 py-3 ">
                                                <div className='col-12 text-start d-flex font-13 px-1 pb-1 new-font-style'>
                                                    <label>Driver</label>
                                                    {fromadminorschool != 2 &&
                                                        <div className='ps-2'>
                                                            <OverlayTrigger
                                                                trigger="click"
                                                                show={drivershowPopover}
                                                                onToggle={handleToggleDriver}
                                                                overlay={popoverDriver}
                                                            >
                                                                <a href="#" role="button" onClick={(e) => e.preventDefault()}>
                                                                    <img src="/images/InfoBtn.svg" title="Show Email and Contact Number" className="cursor-pointer" height='16px' />
                                                                </a>
                                                            </OverlayTrigger>
                                                        </div>
                                                    }
                                                </div>
                                                <div className='row pe-2'>
                                                    <div className='col-md-12 pe-0'>
                                                        <select name='driver'
                                                            style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                            disabled={fromadminorschool != 2}
                                                            value={showOtherDrivermanager ? "other" : k12TechData.driver}
                                                            onChange={(e) => {
                                                                if (e.target.value == "other") {
                                                                    setshowOtherDrivermanager(true);
                                                                    setK12TechData({ ...k12TechData, driver: "0" });
                                                                } else {
                                                                    setshowOtherDrivermanager(false);
                                                                    setK12TechData({ ...k12TechData, driver: e.target.value });
                                                                }
                                                            }}>
                                                            <option value="0">Select</option>
                                                            {allDriver?.filter((item) => item.flag == 1).map((item, i) => {
                                                                return <option key={i} value={item.id}>{item.first_name} {item.last_name}</option>
                                                            })}
                                                            <option value="other">Other</option>
                                                        </select>
                                                    </div>
                                                    {showOtherDrivermanager == 1 &&
                                                        <div className='col-md-12 pe-0'>
                                                            <select name='driver' className="mt-3"
                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                disabled={fromadminorschool != 2}
                                                                value={k12TechData.driver}
                                                                onChange={(e) => setK12TechData({ ...k12TechData, driver: e.target.value })}>
                                                                <option value="0">Select</option>
                                                                {allDriver?.filter((item) => item.flag != 1).map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.first_name} {item.last_name}</option>
                                                                })}
                                                            </select>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 text-end py-3">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('MainContactDiv', validateMainContactExtras)}>Save Contact Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>
                                </div>
                            </div>
                        </div>


                        {/* account information section */}
                        {fromadminorschool == 2 ? (
                            <div className='pt-3'>
                                <div className='col-12  pb-2'>
                                    <label className='schoolprofile-headers'>Account Information</label>
                                </div>
                                <div className="GridBox p-2 align-items-center parent" id='AccountDetailsDiv' >
                                    <div className='row'>
                                        <div className="col-xl-4 col-12 pt-3">
                                            <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                <div className='col-12 text-start px-1 pb-1 new-font-style'>Customer</div>
                                                <div className='col-md-12 font-13 ps-3'>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name='customer'
                                                            checked={SchoolProfile.customer == 1}
                                                            onChange={(e) => setSchoolProfile({ ...SchoolProfile, customer: 1 })}
                                                        />
                                                        <label className={`form-check-label ${SchoolProfile.customer == 1 ? 'fw-bold' : ''}`}>Yes</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name='customer'
                                                            checked={SchoolProfile.customer == 2}
                                                            onChange={(e) => setSchoolProfile({ ...SchoolProfile, customer: 2 })}
                                                        />
                                                        <label className={`form-check-label ${SchoolProfile.customer == 2 ? 'fw-bold' : ''}`}>No</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Enrollment</div>
                                            <input type="text" autoComplete='off' name='enrollment' className="form-control"
                                                value={SchoolProfile.enrollment}
                                                onChange={(e) => {
                                                    const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                    setSchoolProfile({ ...SchoolProfile, enrollment: onlyNumbers });
                                                }} />
                                        </div>
                                        {show_partnership_reseller &&
                                            <div className="col-xl-4 col-12 py-3 ">
                                                <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Partnerships</div>
                                                <select name='partnership' value={k12TechData.partnership}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        const selectedReseller = AllResellers.find(r => r.id.toString() == selectedId);

                                                        setK12TechData({
                                                            ...k12TechData,
                                                            partnership: selectedId,
                                                        });
                                                    }}>
                                                    <option value="0">Select</option>
                                                    {AllResellers?.map((item, i) => {
                                                        return <option key={i} value={item.id}>{item.name}</option>
                                                    })}
                                                </select>
                                            </div>
                                        }
                                        <div className='col-xl-4 col-12 py-3'>
                                            <div>Upload Document</div>
                                            <div className="col-12">
                                                <input
                                                    type="file"
                                                    ref={ImportDevicesFile}
                                                    name="upload_fileforimportdevices"
                                                    id="UploadFileForImportDevices"
                                                    accept='.pdf'
                                                    onChange={ShowFileName}
                                                />
                                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadFileForImportDevices" style={{ borderRadius: '15px' }}>
                                                    Upload Document
                                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                                </label>

                                                <div className='col-md-12 pe-0'>
                                                    <div className="ps-2" style={{ fontWeight: "600", color: 'green' }}>
                                                        {SchoolProfile?.Document && (
                                                            <label className='d-flex cursor-pointer'>
                                                                <label onClick={(e) => openPDFInNewTab(SchoolProfile?.Document)}>
                                                                    <u>{SchoolProfile.FileName || SchoolProfile?.Document}</u>
                                                                </label>
                                                                <img className='ps-2' src="/images/CancelIcon.svg" title='Remove' onClick={() => setSchoolProfile({ ...SchoolProfile, FileName: '', Document: '' })} />
                                                            </label>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 text-end py-3">
                                        <button className="SaveBtn" onClick={(e) => handleSaveSection('AccountDetailsDiv', null)}>Save Account Information</button>
                                        <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='pt-3'>
                                <div className='col-12  pb-2'>
                                    <label className='schoolprofile-headers'>Account Information</label>
                                </div>
                                <div className="GridBox p-2 align-items-center parent" id='AccountDetailsDiv' >
                                    <div className='row'>
                                        {show_partnership_reseller &&
                                            <div className='col-xl-4 col-12 py-3'>
                                                <div>Partnerships : {AllResellers?.find(r => r.id.toString() == k12TechData.partnership)?.name || "-"}</div>
                                                <div className='col-md-12 pe-0'>
                                                    <label></label>
                                                </div>
                                            </div>
                                        }

                                        <div className='col-xl-8 col-12 py-3 d-flex'>
                                            <div>Uploaded Document :</div>
                                            <div className=''>
                                                <div className="ps-2" style={{ fontWeight: "600", color: 'green' }}>
                                                    {SchoolProfile?.Document ? (
                                                        <label className='d-flex cursor-pointer' onClick={(e) => openPDFInNewTab(SchoolProfile?.Document)}>
                                                            <u> {SchoolProfile.FileName || SchoolProfile?.Document}</u>
                                                        </label>
                                                    ) : (<>-</>)}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-xl-12 col-12 pb-3'>
                                            <label className='fw-600'>PartnerShip Approval Status</label>
                                            <div className='d-flex'>
                                                {statusOptions.map((option) => (
                                                    <label key={option.id} className="d-flex align-items-center me-4">
                                                        <input
                                                            type="radio"
                                                            name="partnerShipApprovalStatus"
                                                            value={option.id}
                                                            checked={SchoolProfile?.approvalStatus == option.id}
                                                            onChange={(e) => setSchoolProfile({ ...SchoolProfile, approvalStatus: e.target.value })}
                                                            className="form-check-input me-1 d-flex"
                                                        />
                                                        <label>{option.label}</label>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 text-end py-3">
                                        <button className="SaveBtn" onClick={(e) => handleSaveSection('AccountDetailsDiv', null)}>Save Account Information</button>
                                        <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* shipping details section */}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Shipping Information</label>
                            </div>
                            <div className="GridBox p-2 align-items-center parent" id='ShippingDetailsDiv' >
                                <div className='row'>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>
                                            Shipping - Company/{organization} Name</div>
                                        <input type="text" autoComplete='off' name='fedex_company_name'
                                            className="form-control" value={shippingDetails.fedex_company_name}
                                            onChange={(e) => setShippingDetails({ ...shippingDetails, fedex_company_name: e.target.value })}
                                        />

                                    </div>
                                    <div className="col-xl-3 col-12 pe-0 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Number</div>
                                        <input type="text" autoComplete='off' name='Phoneno' className="form-control"
                                            value={shippingDetails.Phoneno} maxLength={10}
                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                setShippingDetails({ ...shippingDetails, Phoneno: onlyNumbers });
                                            }}
                                        />

                                    </div>
                                    <div className="col-xl-1 col-12 pt-3 ps-0">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Ext</div>
                                        <input type="text" autoComplete='off' name='shippingextension' className="form-control"
                                            value={shippingDetails.shippingextension}
                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                setShippingDetails({ ...shippingDetails, shippingextension: onlyNumbers });
                                            }}

                                        />
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Street Line 1</div>
                                        <input type="text" autoComplete='off' name='Street1' className="form-control"
                                            value={shippingDetails.Street1} onChange={(e) => setShippingDetails({ ...shippingDetails, Street1: e.target.value })}
                                        />

                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-13 pb-1 new-font-style'>Street Line 2</div>
                                        <input type="text" autoComplete='off' name='Street2' className="form-control"
                                            value={shippingDetails.Street2} onChange={(e) => setShippingDetails({ ...shippingDetails, Street2: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>City</div>
                                        <input type="text" autoComplete='off' name='city' className="form-control"
                                            value={shippingDetails.city}
                                            onChange={(e) => {
                                                const newCity = e.target.value;
                                                setShippingDetails(prev => ({ ...prev, city: newCity }));
                                            }}
                                        />

                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>State</div>
                                        <select name='state' value={shippingDetails.state}
                                            onChange={(e) => {
                                                const newState = e.target.value;
                                                setShippingDetails(prev => ({ ...prev, state: newState }));
                                            }}>
                                            <option value="0">Select</option>
                                            {AllState.map((item, i) => {
                                                return <option key={i} value={item.state_code}>{item.state_code}</option>
                                            })}
                                        </select>

                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Zip Code</div>
                                        <input type="number" autoComplete='off' name='postalcode' className="form-control"
                                            value={shippingDetails.postalcode}
                                            onChange={(e) => {
                                                const newPostalCode = e.target.value;
                                                setShippingDetails(prev => ({ ...prev, postalcode: newPostalCode }));
                                            }}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>
                                    <div className='col-xl-4 col-12 pt-5'>
                                        <input
                                            id={`mailingaddress`}
                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                            type="checkbox"
                                            name='pickuplocation'
                                            checked={mailingaddress == 1}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setMailingAddress(isChecked ? 1 : 0);
                                            }}
                                        />
                                        <label htmlFor={`mailingaddress`}
                                            className={`form-check-label ${mailingaddress == 1 ? 'fw-bold' : ''}`}>
                                            Mailing / Promotional Address
                                        </label>
                                        <OverlayTrigger
                                            trigger="click"
                                            show={showAddressPopover}
                                            onToggle={handleToggleAddress}
                                            overlay={
                                                <Popover style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowAddressPopover(false)}>
                                                    <Popover.Body>
                                                        Items coming from {enterprise_name} could be anything from case samples, thank you cards, or other materials {enterprise_name || primary_text} sends out throughout the year.
                                                    </Popover.Body>
                                                </Popover>
                                            }
                                        >
                                            <a href="#" role="button" onClick={(e) => e.preventDefault()}>
                                                <img src="/images/InfoBtn.svg" title="Show Email and Contact Number" className="ps-2 cursor-pointer" height='16px' />
                                            </a>
                                        </OverlayTrigger>
                                    </div>
                                    <div className='col-xl-4 col-12 pt-5'>
                                        <input
                                            id={`mainshippinglocation`}
                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                            type="checkbox"
                                            name='pickuplocation'
                                            checked={mainshippinglocation == 1}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setMainShippingLocation(isChecked ? 1 : 0);
                                            }}
                                        />
                                        <label htmlFor={`mainshippinglocation`}
                                            className={`form-check-label ${mainshippinglocation == 1 ? 'fw-bold' : ''}`}>
                                            Main Device Shipping Location
                                        </label>
                                    </div>
                                    {fromadminorschool == 2 && (
                                        <div className='col-xl-4 col-12 pt-3'>
                                            <input
                                                id={`pickupTimingForSchool`}
                                                className="form-check-input mt-1 me-2 cursor-pointer"
                                                type="checkbox"
                                                name='pickuplocation'
                                                checked={pickupTimingForSchool == 1}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setPickupTimingForSchool(isChecked ? 1 : 2);
                                                }}
                                            />
                                            <label htmlFor={`pickupTimingForSchool`}
                                                className={`form-check-label ${pickupTimingForSchool == 1 ? 'fw-bold' : ''}`}>
                                                Allow {organization} to Schedule Pickups?
                                            </label>
                                        </div>
                                    )}
                                    <div className="col-12 col-12 pt-3 ">
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>{ShippingType == 1 ? 'Local Pick-Up/Dropoff Location(s)' : 'Alternate Delivery Locations'}{mainshippinglocation == 0 && <label className='redText'>*</label>}</div>
                                            <div className='col-md-12 row font-13 ps-3 pt-3'>
                                                {allPickUpLocations?.map((account, index) => {
                                                    const idString = account.id;
                                                    const isChecked = shippingDetails?.pickuplocations?.includes(idString);
                                                    return (
                                                        <div className="col-md-3 font-13 d-flex align-items-start mb-3" key={index}>
                                                            <input
                                                                id={`pickuplocation-${account.id}`}
                                                                className="form-check-input mt-1 me-2 cursor-pointer"
                                                                type="checkbox"
                                                                name='pickuplocation'
                                                                aria-label={account.id}
                                                                checked={isChecked}
                                                                onChange={(e) => {
                                                                    const updated = [...(shippingDetails.pickuplocations || [])];
                                                                    if (e.target.checked) {
                                                                        if (!updated.includes(idString)) updated.push(idString);
                                                                    } else {
                                                                        const indexToRemove = updated.indexOf(idString);
                                                                        if (indexToRemove > -1) updated.splice(indexToRemove, 1);
                                                                    }
                                                                    setShippingDetails({ ...shippingDetails, pickuplocations: updated });
                                                                }}
                                                            />
                                                            <label htmlFor={`pickuplocation-${account.id}`}
                                                                className={`form-check-label text-break ${isChecked ? 'fw-bold' : ''}`}>
                                                                {account.name}
                                                            </label>
                                                            <img src='/images/EditIconNew.svg' title="Show Address" className="cursor-pointer ps-2 mt-1"
                                                                onClick={() => { setBuildingAddressPopup(true); setSelectedBuildingAddress(account) }} />
                                                        </div>
                                                    )
                                                })}
                                                <div className="col-md-3 font-13 d-flex align-items-start">
                                                    <input
                                                        id={`pickuplocation-0`}
                                                        className="form-check-input mt-1 me-2 cursor-pointer"
                                                        type="checkbox"
                                                        name='pickuplocation'
                                                        checked={shippingDetails?.pickuplocations?.includes("0")}
                                                        onChange={(e) => {
                                                            const updated = [...(shippingDetails.pickuplocations || [])];
                                                            if (e.target.checked) {
                                                                if (!updated.includes("0")) updated.push("0");
                                                            } else {
                                                                const indexToRemove = updated.indexOf("0");
                                                                if (indexToRemove > -1) updated.splice(indexToRemove, 1);
                                                                setShippingDetails(prev => ({ ...prev, buildingname: "" }));
                                                            }
                                                            setShippingDetails({ ...shippingDetails, pickuplocations: updated });
                                                        }}
                                                    />
                                                    <label className={`form-check-label ${shippingDetails?.pickuplocations?.includes("0") ? 'fw-bold' : ''}`}>
                                                        Other
                                                    </label>
                                                </div>
                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.pickuplocationError}
                                            </span>
                                            {shippingDetails?.pickuplocations?.includes("0") && (
                                                <div className="col-xl-4 col-12 pt-3 ">
                                                    <div className='col-12 text-start px-1 font-13 pb-1 new-font-style'>Enter Building<label className='redText'>*</label></div>
                                                    <input type="text" autoComplete='off' name='buildingname' className="form-control" required
                                                        value={shippingDetails.buildingname || ""} onChange={(e) => setShippingDetails({ ...shippingDetails, buildingname: e.target.value })} />
                                                    <span className="form-text invalid-feedback" >
                                                        *required
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                    </div>

                                </div>
                                <div className="col-12 text-end py-3">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('ShippingDetailsDiv', validateShippingExtras)}>Save Shipping Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>
                                </div>
                            </div>
                        </div>

                        {/* device information section*/}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Device Information</label>
                            </div>
                            <div className="GridBox  p-2 align-items-center parent" id='DeviceDetailsDiv' >
                                <div className='row '>
                                    <div className="col-xl-6 col-12 pt-3">
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Devices in District</div>
                                            <div className='col-md-12 font-13 ps-3 row'>
                                                {deviceDistricts.map((brand, index) => (
                                                    <div className="col-6 font-13 pb-1 d-flex align-items-center" key={index}>
                                                        <input
                                                            id={`device-${brand.id}`}
                                                            className="form-check-input mt-0 me-2 cursor-pointer"
                                                            type="checkbox"
                                                            name='devicesindistrict'
                                                            checked={deviceInformation?.devicesindistrict?.includes(String(brand.id)) || false}
                                                            onChange={(e) => handleDeviceDistrictCheckboxChange(e, brand.id)}
                                                        />
                                                        <label htmlFor={`device-${brand.id}`}
                                                            className={`form-check-label ${deviceInformation?.devicesindistrict?.includes(String(brand.id)) ? 'fw-bold' : ''
                                                                }`}
                                                        >
                                                            {brand.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.deviceDistrictsError}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>
                                            How many loaner devices do you have? We recommend between 2-4%.</div>
                                        <input type="number" autoComplete='off' name='countofloaner' className="form-control"
                                            value={loanerAsset.countofLoanerDevice}
                                            onChange={(e) => setLoanerAsset({ ...loanerAsset, countofLoanerDevice: e.target.value })}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>
                                </div>

                                <div className="col-12 text-end pt-4">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('DeviceDetailsDiv', validateDeviceDetails)}>Save Device Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>

                                </div>
                            </div>
                        </div>

                        {/* repair details section */}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Repair Information</label>
                            </div>
                            <div className="GridBox  p-2  align-items-center parent" id="RepairDetailsDiv" >
                                <div className='row'>
                                    <div className='row'>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-13 pb-1 new-font-style'>Weekly Repairs</div>
                                            <input type="text" autoComplete='off' name='weeklyrepairs' className="form-control"
                                                value={deviceInformation.weeklyrepairs} disabled />
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Repair Notes</div>
                                            <textarea disabled={fromadminorschool != 2} rows={1} autoComplete='off' name='repairnotes' className="form-control"
                                                value={repairDetails.repairNotes}
                                                onChange={(e) => {
                                                    setRepairDetails({ ...repairDetails, repairNotes: e.target.value });
                                                    createStringForRepairDetails('repair_notes')
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>{organization} Closes Tickets?</div>
                                            <div className='col-md-12 font-13 ps-3'>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name='partsOrder'
                                                        checked={repairDetails.schoolclosetickets == 1}
                                                        onChange={(e) => {
                                                            setRepairDetails({ ...repairDetails, schoolclosetickets: 1 });
                                                            createStringForRepairDetails('school_close_ticket')
                                                        }}
                                                    />
                                                    <label className={`form-check-label ${repairDetails.schoolclosetickets == 1 ? 'fw-bold' : ''}`}>Yes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name='partsOrder'
                                                        checked={repairDetails.schoolclosetickets == 2}
                                                        onChange={(e) => {
                                                            setRepairDetails({ ...repairDetails, schoolclosetickets: 2 });
                                                            createStringForRepairDetails('school_close_ticket')
                                                        }}
                                                    />
                                                    <label className={`form-check-label ${repairDetails.schoolclosetickets == 2 ? 'fw-bold' : ''}`}>No</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {fromadminorschool == 2 &&
                                        <>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Minimum Repair Grade</div>
                                                    <div className='col-md-12 font-13 ps-3 '>
                                                        {minimumRepairGrade.map((repairgrade, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`repairgrade-${repairgrade.id}`}
                                                                    className="form-check-input me-2 cursor-pointer"
                                                                    type="radio"
                                                                    aria-label={repairgrade.id}
                                                                    name='minRepairGrade'
                                                                    checked={repairDetails.minRepairGrade == repairgrade.id}
                                                                    onChange={(e) => {
                                                                        setRepairDetails({ ...repairDetails, minRepairGrade: repairgrade.id });
                                                                        createStringForRepairDetails('min_repair_grade')
                                                                    }}
                                                                />
                                                                <label htmlFor={`repairgrade-${repairgrade.id}`}
                                                                    className={`form-check-label ${repairDetails.minRepairGrade == repairgrade.id ? 'fw-bold' : ''}`}>

                                                                    {repairgrade.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Repair Price Tier</div>
                                                    <div className='col-md-12 font-13 ps-3 '>
                                                        {repairPriceTier.map((repairprice, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`repairpricetier-${repairprice.id}`}
                                                                    className="form-check-input me-2 cursor-pointer"
                                                                    type="radio"
                                                                    aria-label={repairprice.id}
                                                                    name='repairPriceTier'
                                                                    checked={repairDetails.repairPriceTier == repairprice.id}
                                                                    onChange={(e) => {
                                                                        setRepairDetails({ ...repairDetails, repairPriceTier: repairprice.id });
                                                                        createStringForRepairDetails('repair_price_tier')
                                                                    }}
                                                                />
                                                                <label htmlFor={`repairpricetier-${repairprice.id}`}
                                                                    className={`form-check-label ${repairDetails.repairPriceTier == repairprice.id ? 'fw-bold' : ''}`}
                                                                >
                                                                    {repairprice.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {repairDetails.repairPriceTier == 4 &&
                                                        <div className="col-12 pt-3">
                                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Notes</div>
                                                            <textarea rows={1} autoComplete='off' name='deductiblenotes' className="form-control"
                                                                value={repairDetails.repairpricetiernotes} onChange={(e) => {
                                                                    setRepairDetails({ ...repairDetails, repairpricetiernotes: e.target.value });
                                                                    createStringForRepairDetails('price_tier_notes')
                                                                }}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start pb-1 new-font-style'>Quoting Needed?</div>
                                                    <div className='col-md-12 font-13 pt-2 ps-3'>
                                                        {quotingNeeded.map((quote, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`quotingNeeded-${quote.id}`}
                                                                    className="form-check-input me-2 cursor-pointer"
                                                                    type="radio"
                                                                    aria-label={quote.id}
                                                                    name='quotingNeeded'
                                                                    checked={repairDetails.quotingNeeded == quote.id}
                                                                    onChange={(e) => {
                                                                        setRepairDetails({ ...repairDetails, quotingNeeded: quote.id });
                                                                        createStringForRepairDetails('quoting_needed')
                                                                    }}
                                                                />
                                                                <label htmlFor={`quotingNeeded-${quote.id}`}
                                                                    className={`form-check-label ${repairDetails.quotingNeeded == quote.id ? 'fw-bold' : ''}`}
                                                                >
                                                                    {quote.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-xl-4 col-12 pt-3'>
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Deductible?</div>
                                                    <div className='col-md-12 font-13 ps-3'>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name='deductible'
                                                                checked={repairDetails.deductible == 1}
                                                                onChange={(e) => {
                                                                    setRepairDetails({ ...repairDetails, deductible: 1 });
                                                                    createStringForRepairDetails('deductible')
                                                                }}
                                                            />
                                                            <label className={`form-check-label ${repairDetails.deductible == 1 ? 'fw-bold' : ''}`}>Yes</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name='deductible'
                                                                checked={repairDetails.deductible == 2}
                                                                onChange={(e) => {
                                                                    setRepairDetails({ ...repairDetails, deductible: 2 });
                                                                    createStringForRepairDetails('deductible')
                                                                }}
                                                            />
                                                            <label className={`form-check-label ${repairDetails.deductible == 2 ? 'fw-bold' : ''}`}>No</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 pt-3">
                                                        <div className='col-12 text-start px-1 pb-1 new-font-style'>Deductible Notes</div>
                                                        <textarea rows={1} autoComplete='off' name='deductiblenotes' className="form-control"
                                                            value={repairDetails.deductibleNotes} onChange={(e) => setRepairDetails({ ...repairDetails, deductibleNotes: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </>
                                    }
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ backgroundColor: `${fromadminorschool != 2 && '#f0f0f1'}`, border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Cosmetic Damage Repaired?</div>
                                            <div className='col-md-12 font-13 ps-3'>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name='cosmeticDamageRepaird'
                                                        disabled={fromadminorschool != 2}
                                                        checked={repairDetails.cosmeticDamageRepaird == 1}
                                                        onChange={(e) => {
                                                            setRepairDetails({ ...repairDetails, cosmeticDamageRepaird: 1 });
                                                            createStringForRepairDetails('cosmetic_damage')
                                                        }}
                                                    />
                                                    <label className={`form-check-label ${repairDetails.cosmeticDamageRepaird == 1 ? 'fw-bold' : ''}`}
                                                    >Yes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name='cosmeticDamageRepaird'
                                                        disabled={fromadminorschool != 2}
                                                        checked={repairDetails.cosmeticDamageRepaird == 2}
                                                        onChange={(e) => {
                                                            setRepairDetails({ ...repairDetails, cosmeticDamageRepaird: 2 });
                                                            createStringForRepairDetails('cosmetic_damage')
                                                        }}
                                                    />
                                                    <label className={`form-check-label ${repairDetails.cosmeticDamageRepaird == 2 ? 'fw-bold' : ''}`}>No</label>
                                                </div>
                                            </div>
                                            {repairDetails.cosmeticDamageRepaird == 1 &&
                                                <div className='col-12 row ps-2'>
                                                    <div className='col-12 text-start px-1 new-font-style'>Select Damage Repaired</div>
                                                    {cosmeticDamage.map((cosmetic, index) => (
                                                        <div className="col-md-6 font-13 d-flex align-items-center" key={index}>
                                                            <input
                                                                id={`cosmeticdamage-${cosmetic.id}`}
                                                                className="form-check-input mt-1 me-2 cursor-pointer"
                                                                type="checkbox"
                                                                name='cosmeticdamage'
                                                                aria-label={cosmetic.id}
                                                                disabled={fromadminorschool != 2}
                                                                checked={repairDetails?.selectedDamageRepaird?.includes(String(cosmetic.id)) || false}
                                                                onChange={(e) => handleCosmeticDamageCheckboxChange(e, cosmetic.id)}
                                                            />
                                                            <label htmlFor={`cosmeticdamage-${cosmetic.id}`}
                                                                className={`form-check-label ${repairDetails?.selectedDamageRepaird?.includes(String(cosmetic.id)) ? 'fw-bold' : ''}`}
                                                            >
                                                                {cosmetic.name}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>

                                            }
                                            <div className="col-12 pt-3">
                                                <div className='col-12 text-start px-1 pb-1 new-font-style'>Cosmetic Damage Notes</div>
                                                <textarea rows={1} autoComplete='off' name='cosmeticdamagenotes' className="form-control"
                                                    value={repairDetails.cosmeticdamageNotes} onChange={(e) => setRepairDetails({ ...repairDetails, cosmeticdamageNotes: e.target.value })}
                                                    disabled={fromadminorschool != 2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ backgroundColor: `${fromadminorschool != 2 && '#f0f0f1'}`, border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Pick-Up Day</div>
                                            {routeDay.map((day, index) => (
                                                <div className="font-13 d-flex ps-3 align-items-center" key={index}>
                                                    <input
                                                        id={`routeday-${day.id}`}
                                                        className="form-check-input mt-1 me-2 cursor-pointer"
                                                        type="radio"
                                                        aria-label={day.id}
                                                        name="routeDay"
                                                        checked={repairDetails.routeDay == day.id}
                                                        disabled={fromadminorschool != 2}
                                                        onChange={(e) => setRepairDetails({ ...repairDetails, routeDay: day.id })}
                                                    />
                                                    <label htmlFor={`routeday-${day.id}`} className={`form-check-label ${repairDetails.routeDay == day.id ? 'fw-bold' : ''}`}>
                                                        {day.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ backgroundColor: `${fromadminorschool != 2 && '#f0f0f1'}`, border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Route Frequency</div>
                                            {routeFrequency.map((route, index) => (
                                                <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                    <input
                                                        id={`routefrequency-${route.id}`}
                                                        className="form-check-input me-2 cursor-pointer"
                                                        type="radio"
                                                        aria-label={route.id}
                                                        name='routeFrequency'
                                                        checked={repairDetails.routeFrequency == route.id}
                                                        disabled={fromadminorschool != 2}
                                                        onChange={(e) => {
                                                            setRepairDetails({ ...repairDetails, routeFrequency: route.id });
                                                            createStringForRepairDetails('route_frequency')
                                                        }}
                                                    />
                                                    <label htmlFor={`routefrequency-${route.id}`} className={`form-check-label ${repairDetails.routeFrequency == route.id ? 'fw-bold' : ''}`}>
                                                        {route.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>What should we do if we receive devices that are not covered?</div>
                                            <div className='col-md-12 font-13 ps-3'>
                                                {uncoveredDevices.map((quote, index) => (
                                                    <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                        <input
                                                            id={`uncoveredDevices-${quote.id}`}
                                                            className="form-check-input me-2 cursor-pointer"
                                                            type="radio"
                                                            aria-label={quote.id}
                                                            name='uncovereddevice'
                                                            checked={repairDetails.uncovereddevice == quote.id}
                                                            onChange={(e) => {
                                                                setRepairDetails({ ...repairDetails, uncovereddevice: quote.id });
                                                                createStringForRepairDetails('not_covered_device')
                                                            }}
                                                        />
                                                        <label htmlFor={`uncoveredDevices-${quote.id}`} className={`form-check-label ${repairDetails.uncovereddevice == quote.id ? 'fw-bold' : ''}`}>
                                                            {quote.name}
                                                        </label>
                                                    </div>
                                                ))}

                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.uncovereddeviceError}
                                            </span>
                                            {repairDetails.uncovereddevice == 4 &&
                                                <div className='col-12 pt-3'>
                                                    <div className='col-12 font-13 text-start pb-1 new-font-style'>
                                                        Describe what to do
                                                    </div>
                                                    <textarea rows={2} autoComplete='off' name='describewhattodo' className="form-control"
                                                        value={repairDetails.uncovereddeviceNotes} onChange={(e) => {
                                                            setRepairDetails({ ...repairDetails, uncovereddeviceNotes: e.target.value });
                                                            createStringForRepairDetails('uncovered_receive_notes')
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Additional Asset Management</div>
                                            <div className='col-md-12 font-13 ps-3'>
                                                {additionalAssetManagement.map((assets, index) => (
                                                    <div className="font-13" key={index}>
                                                        <input
                                                            id={`assets-${assets.id}`}
                                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                                            type="checkbox"
                                                            name='additionalAssets'
                                                            aria-label={assets.id}
                                                            checked={loanerAsset?.additionalAssets?.includes(String(assets.id))}
                                                            onChange={(e) => handleAdditionalAssetManagementCheckboxChange(e, assets.id)}
                                                        />
                                                        <label htmlFor={`assets-${assets.id}`}
                                                            className={`form-check-label ${loanerAsset?.additionalAssets?.includes(String(assets.id)) ? 'fw-bold' : ''
                                                                }`}
                                                        >
                                                            {assets.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.assetManagementError}
                                            </span>
                                            {loanerAsset?.additionalAssets?.includes("5") &&
                                                <div className='col-12 pt-3'>
                                                    <div className='col-12 font-13 text-start pb-1 new-font-style'>
                                                        Notes
                                                    </div>
                                                    <textarea rows={2} autoComplete='off' name='additionalassetnotes' className="form-control"
                                                        value={repairDetails.additionalAssetNotes} onChange={(e) => setRepairDetails({ ...repairDetails, additionalAssetNotes: e.target.value })}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <Accordion activeKey={activeKeys}>
                                        <Accordion.Item eventKey="0" className='mt-2'>
                                            <Accordion.Header onClick={() => toggleKey('0')}>Repair Cap
                                            </Accordion.Header>
                                            <Accordion.Body style={{ background: "white" }}>
                                                <div className='row'>
                                                    <div className='col-md-2 font-13 text-start new-font-style'>Device Type</div>
                                                    <div className='col-md-3 font-13 text-start new-font-style'>Repair Cap</div>
                                                    <div className='col-md-3 font-13 text-start new-font-style'>Repair Cap Exceeded</div>
                                                    <div className='col-md-3 font-13 text-start new-font-style'>Notes</div>
                                                </div>

                                                {repairCapRows.map((row, index) => (
                                                    row.flag != 3 &&
                                                    <div className='pt-2 row' key={index}>
                                                        <div className='col-md-2'>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.deviceType}
                                                                onChange={(e) => handleRepairCapChange(index, "deviceType", e.target.value)}
                                                                placeholder="Enter device type"
                                                            />
                                                            <span className="form-text invalid-feedback">  *required</span>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className="input-group ">
                                                                <span className="input-group-text">$</span>
                                                                <input type="number"
                                                                    autoComplete='off' className="form-control"
                                                                    name='repaircap'
                                                                    placeholder='Enter cap amount' pattern="[0-9]+(\.[0-9]+)?"
                                                                    value={row.capAmount}
                                                                    onChange={(e) => handleRepairCapChange(index, "capAmount", e.target.value)}
                                                                    onKeyDown={(e) => {
                                                                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                                <span className="form-text invalid-feedback">  *required</span>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className='col-md-12'>
                                                                <select
                                                                    value={row.capexceeding} onChange={(e) => handleRepairCapChange(index, "capexceeding", e.target.value)}>
                                                                    <option value="0">Select</option>
                                                                    {exceedingCapHandling.map((caphandling, index) => (
                                                                        <option key={index} value={caphandling.id}>{caphandling.name}</option>
                                                                    ))}
                                                                </select>
                                                                <span className="form-text invalid-feedback" >
                                                                    *required
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            {row.capexceeding == 5 ? (
                                                                <div className='col-md-12'>
                                                                    <textarea rows={1} autoComplete='off' name='exceeding_notes' className="form-control"
                                                                        value={row.notes} onChange={(e) => handleRepairCapChange(index, "notes", e.target.value)}
                                                                    />
                                                                </div>) : '-'}
                                                        </div>
                                                        <div className='col-md-1'>
                                                            {repairCapRows.filter(r => r.flag != 3).length > 1 && (
                                                                <img
                                                                    src="/images/CancelIcon.svg"
                                                                    title='Remove'
                                                                    onClick={() => handleRemoveRepairCapRow(index)}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            )}
                                                        </div>

                                                    </div>
                                                ))}

                                                <div className='col-12 pt-2'>
                                                    <label onClick={handleAddRepairCapRow} className="mt-2 text-decoration-underline cursor-pointer">
                                                        Add More
                                                    </label>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className='mt-3'>
                                            <Accordion.Header onClick={() => toggleKey('1')}>Device Login
                                            </Accordion.Header>
                                            <Accordion.Body style={{ background: "white" }}>
                                                {logins.map((login, index) => (
                                                    <div className='row ' key={login.uniqueId}>
                                                        {/* Device selector */}
                                                        {login.credentials.filter(c => c.flag !== 2).length > 0 && (
                                                            <div className='col-md-4 py-2'>
                                                                <div className='col-md-12'>
                                                                    <select
                                                                        value={login.id}
                                                                        onChange={(e) => updateLogin(login.uniqueId, "id", parseInt(e.target.value))}
                                                                        disabled={login.deleteAllFlag}
                                                                    >
                                                                        <option value="0">Select Device</option>
                                                                        <option value="1">Chromebook</option>
                                                                        <option value="2">Windows</option>
                                                                        <option value="3">iPad</option>
                                                                        <option value="4">MacBook</option>
                                                                    </select>
                                                                    <span className="form-text invalid-feedback" >
                                                                        *required
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* Credentials section */}
                                                        <div className='col-md-8 py-2'>
                                                            {login?.credentials?.map((cred, credindex) => (
                                                                cred.flag != 2 &&
                                                                <div key={cred.id} className="row pb-1 align-items-center">
                                                                    <div className='col-md-5'>
                                                                        <input
                                                                            className='form-control'
                                                                            placeholder="Username"
                                                                            value={cred.username}
                                                                            onChange={(e) => updateCredential(login.uniqueId, cred.id, "username", e.target.value)}
                                                                            disabled={login.deleteAllFlag}
                                                                        />
                                                                        <span className="form-text invalid-feedback" >
                                                                            *required
                                                                        </span>
                                                                    </div>

                                                                    <div className='col-md-5 position-relative'>
                                                                        <input
                                                                            className='form-control'
                                                                            type={cred.showPassword ? "text" : "password"}
                                                                            placeholder="Password"
                                                                            value={cred.password}
                                                                            onChange={(e) => updateCredential(login.uniqueId, cred.id, "password", e.target.value)}
                                                                            disabled={login.deleteAllFlag}
                                                                        />
                                                                        <span className="form-text invalid-feedback" >
                                                                            *required
                                                                        </span>
                                                                    </div>

                                                                    <div className='col-md-1 position-relative'>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm position-absolute top-50 translate-middle-y"
                                                                            style={{ right: "-5%" }}
                                                                            onClick={() => togglePasswordVisibility(login.uniqueId, cred.id)}
                                                                            disabled={login.deleteAllFlag}
                                                                        >
                                                                            {cred.showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                                        </button>
                                                                    </div>

                                                                    <div className='col-md-1 d-flex'>
                                                                        {login?.credentials?.filter(r => r.flag != 2)?.length > 1 && (
                                                                            <img
                                                                                src="/images/CancelIcon.svg"
                                                                                title='Remove'
                                                                                onClick={() => removeCredential(login.uniqueId, cred.id)}
                                                                                disabled={login.deleteAllFlag}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            {/* Add/remove buttons */}
                                                            <div className='col-12 text-center'>
                                                                {login.credentials.filter(c => c.flag !== 2).length > 0 && (
                                                                    <label
                                                                        onClick={() => addCredential(login.uniqueId)}
                                                                        className="mt-2 text-decoration-underline cursor-pointer "
                                                                        disabled={login.deleteAllFlag}
                                                                    >
                                                                        Add Another Login
                                                                    </label>
                                                                )}
                                                                {login.credentials.filter(c => c.flag !== 2).length > 0 && (
                                                                    <label
                                                                        onClick={() => removeAllCredentials(login.uniqueId)}
                                                                        className="mt-2 ms-3 custom-text-danger text-decoration-underline cursor-pointer"
                                                                    >
                                                                        Remove Device Type
                                                                    </label>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <span className="Emailinvalid" >
                                                    {deviceloginerror}
                                                </span>
                                                <div className='col-12 pt-3'>
                                                    <button onClick={addLogin} className="BorderBtn">
                                                        Add New Device
                                                    </button>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item className='mt-3' eventKey="2">
                                            <Accordion.Header onClick={() => toggleKey('2')}>Repair Coverage</Accordion.Header>
                                            <Accordion.Body style={{ backgroundColor: `${fromadminorschool != 2 ? '#f0f0f1' : 'white'}` }}>
                                                <div className='row'>
                                                    {repairCoverage.map((repairs, index) => (
                                                        <div key={index} className="col-12 font-13 d-flex flex-column">
                                                            <div className="d-flex align-items-center">
                                                                <input
                                                                    id={`repairs-${repairs.id}`}
                                                                    className="form-check-input mt-1 me-2 cursor-pointer"
                                                                    type="checkbox"
                                                                    name='repairCoverage'
                                                                    aria-label={repairs.id}
                                                                    checked={repairDetails?.repairCoverage?.includes(String(repairs.id)) || false}
                                                                    disabled={fromadminorschool != 2}
                                                                    onChange={(e) => handleRepairCoverageCheckboxChange(e, repairs.id)}
                                                                />
                                                                <label htmlFor={`repairs-${repairs.id}`}
                                                                    className={`form-check-label ${repairDetails?.repairCoverage?.includes(String(repairs.id)) ? 'fw-bold' : ''
                                                                        }`}>
                                                                    {repairs.name}
                                                                </label>
                                                            </div>
                                                            {repairs.id == 1 && repairDetails?.repairCoverage?.includes(String(repairs.id)) && (
                                                                <div className='p-3'>
                                                                    {ASProws.map((row, index) => (
                                                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} key={index} className='p-2 mb-3'>
                                                                            <div className='pt-2 row'>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Type</div>
                                                                                    <select value={row.deviceType} name='devicetype'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "deviceType", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        {deviceDistricts?.map((item, i) => {
                                                                                            return <option key={i} value={item.id}>{item.name}</option>
                                                                                        })
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Model</div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={row.deviceModel}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "deviceModel", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}

                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Coverage Type</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.coverageType}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "coverageType", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="CLW">CLW</option>
                                                                                        <option value="ADP">ADP</option>
                                                                                    </select>

                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Coverage Start Date</div>
                                                                                    <CustomReactDatePicker
                                                                                        selectedDate={row.startDate ? ymdToDate(row.startDate) : null}
                                                                                        onChangeHandler={(date) => handleASPRepairCoverageChange(index, "startDate", date ? YYYYMMDD(date) : "")}
                                                                                        isDisabled={fromadminorschool != 2}
                                                                                        placeholderText="MM-DD-YYYY"
                                                                                    />

                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Coverage End Date</div>
                                                                                    <CustomReactDatePicker
                                                                                        selectedDate={row.endDate ? ymdToDate(row.endDate) : null}
                                                                                        onChangeHandler={(date) => handleASPRepairCoverageChange(index, "endDate", date ? YYYYMMDD(date) : "")}
                                                                                        isDisabled={fromadminorschool != 2}
                                                                                        placeholderText="MM-DD-YYYY"
                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Carted</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.carted}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "carted", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Cases</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.cases}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "cases", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                        <option value="3">Sleeve</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Screen</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.screen}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "screen", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Non-Touch</option>
                                                                                        <option value="2">Touch</option>
                                                                                        <option value="3">2-in-1</option>
                                                                                        <option value="4">Tablet </option>
                                                                                    </select>
                                                                                </div>
                                                                                {asperror === index && (
                                                                                    <div className='redText'>All fields are required!</div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <div className='col-12 text-center pt-2'>
                                                                        <label onClick={handleAddNewASPRows} className="mt-2 text-decoration-underline cursor-pointer ">
                                                                            Add More
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {repairs.id == 3 && repairDetails?.repairCoverage?.includes(String(repairs.id)) && (
                                                                <div className='p-3'>
                                                                    {show_part_order_module &&
                                                                        <div className='font-13 ps-3 d-flex mb-3'>
                                                                            <div>
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        checked={SchoolProfile.partsOrder == 1}
                                                                                        onChange={(e) =>
                                                                                            setSchoolProfile({ ...SchoolProfile, partsOrder: e.target.checked ? 1 : 0 })
                                                                                        }
                                                                                    />
                                                                                    <label className="form-check-label">
                                                                                        Create Parts Orders
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <div className='ps-3'>
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        checked={SchoolProfile.RCS == 1}
                                                                                        onChange={(e) =>
                                                                                            setSchoolProfile({ ...SchoolProfile, RCS: e.target.checked ? 1 : 0 })
                                                                                        }
                                                                                    />
                                                                                    <label className="form-check-label">
                                                                                        RCS
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {ADProws.map((row, index) => (
                                                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} key={index} className='p-2 mb-3'>
                                                                            <div className='pt-2 row'>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Type</div>
                                                                                    <select value={row.deviceType} name='devicetype'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "deviceType", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        {deviceDistricts?.map((item, i) => {
                                                                                            return <option key={i} value={item.id}>{item.name}</option>
                                                                                        })
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Model</div>

                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={row.deviceModel}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "deviceModel", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>{coverage} Start Date</div>
                                                                                    <CustomReactDatePicker
                                                                                        selectedDate={row.startDate ? ymdToDate(row.startDate) : null}
                                                                                        onChangeHandler={(date) => handleADPRepairCoverageChange(index, "startDate", date ? YYYYMMDD(date) : "")}
                                                                                        isDisabled={fromadminorschool != 2}
                                                                                        placeholderText="MM-DD-YYYY"
                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>{coverage} End Date</div>
                                                                                    <CustomReactDatePicker
                                                                                        selectedDate={row.endDate ? ymdToDate(row.endDate) : null}
                                                                                        onChangeHandler={(date) => handleADPRepairCoverageChange(index, "endDate", date ? YYYYMMDD(date) : "")}
                                                                                        isDisabled={fromadminorschool != 2}
                                                                                        placeholderText="MM-DD-YYYY"
                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Carted</div>
                                                                                    <select value={row.carted} name='carted'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "carted", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Cases</div>
                                                                                    <select value={row.cases} name='cases'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "cases", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                        <option value="3">Sleeve</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Screen</div>
                                                                                    <select value={row.screen} name='screen'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "screen", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Non-Touch</option>
                                                                                        <option value="2">Touch</option>
                                                                                        <option value="3">2-in-1</option>
                                                                                        <option value="4">Tablet</option>
                                                                                    </select>
                                                                                </div>
                                                                                {adperror === index && (
                                                                                    <div className='redText'>All fields are required!</div>
                                                                                )}

                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <div className='col-12 text-center pt-2'>
                                                                        <label onClick={handleAddNewADPRows} className="mt-2 text-decoration-underline cursor-pointer ">
                                                                            Add More
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {repairs.id == 4 && repairDetails?.repairCoverage?.includes(String(repairs.id)) && (
                                                                <div className='p-3'>
                                                                    <div className='row'>
                                                                        <div className='col-md-3'>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Carted</div>
                                                                            <select value={repairCoverageData.parental_carted} name='carted'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, parental_carted: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Yes</option>
                                                                                <option value="2">No</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className='col-md-3'>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Cases</div>
                                                                            <select value={repairCoverageData.parental_cases} name='cases'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, parental_cases: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Yes</option>
                                                                                <option value="2">No</option>
                                                                                <option value="3">Sleeve</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className='col-md-3 '>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Screen</div>
                                                                            <select value={repairCoverageData.parental_screen} name='screen'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, parental_screen: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Non-Touch</option>
                                                                                <option value="2">Touch</option>
                                                                                <option value="3">2-in-1</option>
                                                                                <option value="4">Tablet</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                                <div className="col-12 text-end py-3">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('RepairDetailsDiv', validateRepairDetails)}>Save Repair Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>

                                </div>
                            </div>
                        </div>

                        {/* billing details section */}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Billing Information</label>
                            </div>
                            <div className="GridBox p-2 align-items-center parent" id='BillingDetailsDiv' >
                                <div className='row '>
                                    {fromadminorschool != 2 ?
                                        <div className='col-md-4 col-12 pt-3'>
                                            <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Account Credit</div>
                                            <div className="input-group">
                                                <span className="input-group-text">$</span>
                                                <input type="number" autoComplete='off' className="form-control"
                                                    name='accountcredit'
                                                    placeholder='00' pattern="[0-9]+(\.[0-9]+)?"
                                                    value={billingDetails.accountcredit}
                                                    disabled
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div> :
                                        <div className='col-md-2 col-12 pt-3'>
                                            <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Account Credit</div>
                                            <div className="input-group">
                                                <span className="input-group-text">$</span>
                                                <input type="number" autoComplete='off' className="form-control"
                                                    name='accountcredit'
                                                    placeholder='00' pattern="[0-9]+(\.[0-9]+)?"
                                                    value={billingDetails.accountcredit}
                                                    onChange={(e) => setBillingDetails({ ...billingDetails, accountcredit: e.target.value })}
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    disabled={fromadminorschool != 2}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {fromadminorschool == 2 &&
                                        <>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 pb-1 new-font-style'>Account Credit Notes</div>
                                                <textarea rows={1} autoComplete='off' name='repairnotes' className="form-control"
                                                    value={billingDetails.accountcreditusagenotes} onChange={(e) => setBillingDetails({ ...billingDetails, accountcreditusagenotes: e.target.value })}
                                                />
                                            </div>
                                            <div className="pt-3 w-auto">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='py-2 ps-2 pe-3 h-100'>
                                                    <div className='text-start px-1 pb-2 new-font-style'>Account Credit Usage</div>
                                                    <div className='d-flex gap-3 font-13 ps-3'>
                                                        {accountCreditUsage.map((account, index) => (
                                                            <div className=" d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`accountcredit-${account.id}`}
                                                                    className="form-check-input mt-1 me-2 cursor-pointer"
                                                                    type="checkbox"
                                                                    name='accountcreditusage'
                                                                    aria-label={account.id}
                                                                    checked={billingDetails?.accountcreditusage?.includes(String(account.id)) || false}
                                                                    onChange={(e) => {
                                                                        const isChecked = e.target.checked;
                                                                        const idString = String(account.id);
                                                                        setBillingDetails((prevState) => {
                                                                            const existingUsage = prevState?.accountcreditusage ?? [];
                                                                            return {
                                                                                ...prevState,
                                                                                accountcreditusage: isChecked
                                                                                    ? [...existingUsage.map(String), idString] // Add ID if checked
                                                                                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
                                                                            };
                                                                        });
                                                                    }}
                                                                />
                                                                <label htmlFor={`accountcredit-${account.id}`}
                                                                    className={`form-check-label ${billingDetails?.accountcreditusage?.includes(String(account.id)) ? 'fw-bold' : ''
                                                                        }`}
                                                                >
                                                                    {account.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            {show_pricing_default_custom &&
                                                <div className="col-xl-4 col-12 pt-3">
                                                    <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                        <div className='col-12 text-start px-1 pb-1 new-font-style'>Pricing</div>
                                                        <div className='col-md-12 font-13 ps-3'>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name='pricing'
                                                                    checked={SchoolProfile.pricing == 1}
                                                                    onChange={(e) => setSchoolProfile({ ...SchoolProfile, pricing: 1 })}
                                                                />
                                                                <label className={`form-check-label ${SchoolProfile.pricing == 1 ? 'fw-bold' : ''}`}>Default</label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name='pricing'
                                                                    checked={SchoolProfile.pricing == 2}
                                                                    onChange={(e) => setSchoolProfile({ ...SchoolProfile, pricing: 2 })}
                                                                />
                                                                <label className={`form-check-label ${SchoolProfile.pricing == 2 ? 'fw-bold' : ''}`}>Custom</label>
                                                            </div>
                                                        </div>
                                                        {SchoolProfile.pricing == 2 &&
                                                            <div className="col-12 pt-4 ">
                                                                <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Special Discounts or Pricing</div>
                                                                <textarea rows={1} autoComplete='off' name='billingspecialdiscount' className="form-control"
                                                                    value={billingDetails.discoutpricing} onChange={(e) => setBillingDetails({ ...billingDetails, discoutpricing: e.target.value })}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <input type="checkbox" className='form-check-input' id='secondary-pricing'
                                                    onChange={(e) => setBillingDetails((prev) => ({ ...prev, UseSecondaryPricing: e.target.checked ? 1 : 2 }))}
                                                    checked={billingDetails?.UseSecondaryPricing == 1} />
                                                <label className={`ps-2 ${billingDetails?.UseSecondaryPricing == 1 ? 'fw-bold' : ''}`} htmlFor='secondary-pricing'>Customer Uses Secondary Pricing?</label>
                                            </div>
                                        </>
                                    }

                                </div>
                                <div className="col-12 text-end py-3">
                                    {fromadminorschool == 2 &&
                                        <button className="SaveBtn" onClick={(e) => handleSaveSection('BillingDetailsDiv', null)}>Save Billing Information</button>
                                    }
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>
                                </div>
                            </div>
                        </div>

                        {/* custom pricing section */}
                        {fromadminorschool == 2 &&
                            <div className='pt-3'>
                                <div className='col-12 pb-2'>
                                    <label className='schoolprofile-headers'>Custom Pricing for Parts</label>
                                </div>
                                <div className="GridBox p-2 align-items-center parent" id="CustomPriceParts">
                                    <div className='row mt-2'>
                                        <div className='col-6 position-relative' tabIndex={-1}
                                            onBlur={(e) => {
                                                if (!e.currentTarget.contains(e.relatedTarget)) {
                                                    setAllPartsData(prev => ({ ...prev, searchString: "" }));
                                                    HideShowSuggestionBox(false);
                                                }
                                            }}>
                                            <input id="universal-search-box" className="form-control" autoComplete="off" type="text"
                                                value={allParts.searchString} placeholder="Search master parts to add custom pricing"
                                                onChange={(e) => { setAllPartsData(prev => ({ ...prev, searchString: e.target.value })); GetRepairParts(e.target.value) }}
                                                onPaste={onPasteRestriction}
                                                onKeyDown={onKeyDownRestrict}
                                            />
                                            {allParts.showSuggestionBox && (
                                                <div className="SuggestionBoxDiv" style={{ zIndex: 5, maxHeight: '250px' }}>
                                                    {allParts?.loader ?
                                                        <div className='row'>
                                                            <div className="col-12 text-center pt-2">
                                                                <img src="/images/loder.svg" style={{ width: "30px" }} />
                                                            </div>
                                                        </div>
                                                        : allParts?.data?.filter(part => !customPricePartsArray.some(cp => cp.partId == part.id && (cp.flag == 2 || cp.flag == 3)))?.length != 0 ?
                                                            allParts?.data?.filter(part => !customPricePartsArray.some(cp => cp.partId == part.id && (cp.flag == 2 || cp.flag == 3)))?.map((part) => (
                                                                <div tabIndex={0} className="row brdr-Btm font-14 schoolid p-Suggestion"
                                                                    onClick={() => {
                                                                        const exists = customPricePartsArray.some(p => p.partId === part.id);
                                                                        AddCustomPriceParts(!exists, part);
                                                                    }}>
                                                                    <div className="col-12 text-start d-flex align-items-center">
                                                                        <input type="checkbox" className='form-check-input cursor-pointer'
                                                                            checked={customPricePartsArray.some(p => p.partId === part.id && p.isCheckboxState)}
                                                                            onChange={(e) => AddCustomPriceParts(e.target.checked, part)} />
                                                                        <label className='ps-2 cursor-pointer'>{part.title}</label>
                                                                    </div>
                                                                </div>
                                                            ))
                                                            : <div className="col-12 text-center"> <label> No Record Found </label> </div>
                                                    }
                                                </div>
                                            )}
                                        </div>
                                        <div className='col-12 pt-3'>
                                            {customPricePartsArray?.filter(item => item.flag == 1)?.length > 0 && (
                                                <div className='row mx-0 pb-2'>
                                                    <div className='col-6 font-13'>Part Name</div>
                                                    <div className='col-3 font-13'>Custom Price</div>
                                                    <div className='col-2 font-13'>Original Price</div>
                                                    <div className='col-1 font-13'>Action</div>
                                                </div>
                                            )}
                                            {customPricePartsArray?.filter(item => item.flag == 1)?.map((item, index) => (
                                                <div className='row mx-0 pb-2' key={index}>
                                                    <div className='col-6 position-relative'>
                                                        <input className="form-control" autoComplete="off" type="text"
                                                            placeholder="Search the necessary master part"
                                                            value={item.partName}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className='col-3'>
                                                        <div className="input-group ">
                                                            <span className="input-group-text">$</span>
                                                            <input type="number" className="form-control" placeholder='0' name='partPrice' value={item.newPrice}
                                                                onChange={(e) => {
                                                                    setCustomPricePartsArray(prev => prev.map(row => row.id == item.id
                                                                        ? { ...row, newPrice: e.target.value }
                                                                        : row
                                                                    ));
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                                        e.preventDefault();
                                                                    }
                                                                }} />
                                                        </div>
                                                    </div>
                                                    <div className='col-2'>
                                                        {item.originalPrice != null && item?.originalPrice != ''
                                                            ? `$${item.originalPrice}`
                                                            : '-'}
                                                    </div>
                                                    <div className='col-1'>
                                                        <img src="/images/CancelIcon.svg" title="Remove" className="img-fluid cursor-pointer"
                                                            onClick={() => setCustomPricePartsArray(prev =>
                                                                prev?.map(row => {
                                                                    if (row.id != item.id) return row;
                                                                    // hard delete for new rows make it null, soft delete for existing
                                                                    if (row.flag == 1) return null;
                                                                    if (row.flag == 2) return { ...row, flag: 3 };
                                                                    return row;
                                                                })?.filter(Boolean)
                                                            )} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <Accordion activeKey={activeKeys}>
                                        <Accordion.Item eventKey="4" className='mt-2'>
                                            <Accordion.Header onClick={() => toggleKey('4')}> Custom Pricing for Parts </Accordion.Header>
                                            <Accordion.Body style={{ background: "white" }}>
                                                <div className="col-12 data-table-container greyBox mt-3 overflow-y-auto overflow-x-hidden pt-0" style={{ maxHeight: "300px" }}>
                                                    <table className="table data-table mb-0">
                                                        <thead className='GridHeader sticky-top' style={{ zIndex: 4, backgroundColor: '#f7f8fa' }}>
                                                            <tr>
                                                                <th scope="col" className='fw-600' style={{ paddingTop: '12px', paddingBottom: '10px' }}>Part Name</th>
                                                                <th scope="col" className='fw-600' style={{ paddingTop: '12px', paddingBottom: '10px' }}>Custom Price</th>
                                                                <th scope='col' className='fw-600' style={{ paddingTop: '12px', paddingBottom: '10px' }}>Original Price</th>
                                                                <th scope="col" className='fw-600' style={{ paddingTop: '12px', paddingBottom: '10px' }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {customPricePartsArray?.filter(item => item.flag != 1)?.length == 0 ?
                                                                <tr>
                                                                    <td colSpan={5} className="p-3 text-center">
                                                                        No Record Found
                                                                    </td>
                                                                </tr>
                                                                : customPricePartsArray?.filter(item => item.flag != 1)?.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{item.partName}</td>
                                                                        <td> {item.id == allParts.editPartId ?
                                                                            <div className="input-group ">
                                                                                <span className="input-group-text">$</span>
                                                                                <input type="number" className="form-control" placeholder='0'
                                                                                    name='partPrice' value={item.newPrice} autoFocus
                                                                                    onChange={(e) => {
                                                                                        setCustomPricePartsArray(prev => prev.map(row => row.id == item.id
                                                                                            ? { ...row, newPrice: e.target.value }
                                                                                            : row
                                                                                        ));
                                                                                    }}
                                                                                    onBlur={(e) => {
                                                                                        const clickedSaveBtn = e.relatedTarget?.getAttribute('data-save-id') == item.id;
                                                                                        if (!clickedSaveBtn) {
                                                                                            // Restore original price and close edit
                                                                                            setCustomPricePartsArray(prev => prev.map(row =>
                                                                                                row.id == item.id
                                                                                                    ? { ...row, newPrice: allParts.originalEditPrices }
                                                                                                    : row
                                                                                            ));
                                                                                            setAllPartsData(prev => ({ ...prev, editPartId: null, originalEditPrices: null }));
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }} />
                                                                            </div>
                                                                            : <>${item.newPrice}</>}
                                                                        </td>
                                                                        <td>
                                                                            ${item.originalPrice}
                                                                        </td>
                                                                        <td>
                                                                            <div className='d-flex align-items-center'>
                                                                                {item.id == allParts.editPartId ?
                                                                                    <img src='/images/save_icon.svg' title='Save Price' className='cursor-pointer'
                                                                                        data-save-id={item.id}
                                                                                        tabIndex={0}
                                                                                        onClick={() => {
                                                                                            setAllPartsData(prev => ({ ...prev, editPartId: null }));
                                                                                            addUpdateDeleteSchoolCustomPart(2);
                                                                                        }} />
                                                                                    : <img src='/images/edit_icon.svg' title='Edit Price' className='cursor-pointer'
                                                                                        onClick={() => setAllPartsData(prev => ({ ...prev, editPartId: item.id, originalEditPrices: item.newPrice }))} />
                                                                                }
                                                                                <img src='/images/newDeleteIcon.svg' title='Delete Part' className='cursor-pointer'
                                                                                    onClick={() => {
                                                                                        setCustomPricePartsArray(prev => prev.map(row =>
                                                                                            row.id == item.id ? { ...row, flag: 3 } : row))
                                                                                        setShowPriceDelModal(true)
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 text-end py-3">
                                        <button className="SaveBtn" onClick={() => addUpdateDeleteSchoolCustomPart()}>Save Custom Price Parts</button>
                                        <label className="ms-4 cursor-pointer"
                                            onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}>
                                            <u>Exit</u>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }

                        {/* ticket description section */}
                        {fromadminorschool == 2 &&
                            <div className='pt-3'>
                                <div className='col-12 pb-2'>
                                    <label className='schoolprofile-headers'>NetSuite and Pricing Information</label>
                                </div>
                                <div className="GridBox p-2 align-items-center parent" id="InvoiceDescription" >
                                    <Accordion activeKey={activeKeys}>
                                        <Accordion.Item eventKey="3" className='mt-2'>
                                            <Accordion.Header onClick={() => toggleKey('3')}> NetSuite Information </Accordion.Header>
                                            <Accordion.Body style={{ background: "white" }}>
                                                <div className='row'>
                                                    <div className="col-xl-4 col-12">
                                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Main NetSuite ID</div>
                                                        <input type="number" autoComplete='off' name='customerid'
                                                            className="form-control" value={billingDetails.customerid}
                                                            onChange={(e) => setBillingDetails({ ...billingDetails, customerid: e.target.value })}
                                                            onKeyDown={(e) => { if (["e", "E", "+", "-"]?.includes(e?.key)) { e.preventDefault() } }} />
                                                    </div>
                                                </div>

                                                <div className='row pt-3'>
                                                    <div className='col-xl-12'>
                                                        {buildingNetSuiteIds.length > 0 &&
                                                            buildingNetSuiteIds?.filter(item => item.flag != 0)?.map((item, index) => (
                                                                <div className='row pb-2'>
                                                                    <div className='col-md-4'>
                                                                        <select
                                                                            value={item.buildingId || "0"}
                                                                            name='buildingId'
                                                                            onChange={(e) => {
                                                                                const newBuildingId = e.target.value;
                                                                                setBuildingNetSuiteIds(prev => {
                                                                                    const updated = prev.map(row => {
                                                                                        if (row.id !== item.id) return row;
                                                                                        if (row.addUpdateFlag == 0) return { ...row, buildingId: newBuildingId };
                                                                                        return { ...row, flag: 0 };
                                                                                    });

                                                                                    if (item.addUpdateFlag === 1) {
                                                                                        updated.push({
                                                                                            id: crypto.randomUUID(),
                                                                                            buildingId: newBuildingId,
                                                                                            netSuiteId: item.netSuiteId,
                                                                                            flag: 1,
                                                                                            addUpdateFlag: 0
                                                                                        });
                                                                                    }
                                                                                    return updated;
                                                                                });
                                                                            }}
                                                                        >
                                                                            <option key={-1} value={"0"}>
                                                                                Select Building
                                                                            </option>
                                                                            {allBuilding?.length > 0 && allBuilding?.filter(building =>
                                                                                // exclude buildings already selected in other rows
                                                                                !buildingNetSuiteIds.some(row => row.id != item.id && row.flag != 0 && row.buildingId == building.id
                                                                                ))?.map((building) => (
                                                                                    <option key={building.id} value={building.id}>
                                                                                        {building.name}
                                                                                    </option>
                                                                                ))}
                                                                        </select>
                                                                    </div>
                                                                    {(item.buildingId && item.buildingId != "0") &&
                                                                        <div className='col-md-4'>
                                                                            <input type="number" className='form-control' autoComplete='off'
                                                                                name='netSuiteId' value={item.netSuiteId} placeholder='Enter NetSuite ID'
                                                                                onChange={(e) => {
                                                                                    setBuildingNetSuiteIds(prev => prev.map(row => row.id === item.id
                                                                                        ? { ...row, netSuiteId: e.target.value }
                                                                                        : row
                                                                                    ))
                                                                                }}
                                                                                onKeyDown={(e) => { if (["e", "E", "+", "-"]?.includes(e?.key)) { e.preventDefault() } }}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    <div className="col-md-1">
                                                                        <img src="/images/CancelIcon.svg" title="Remove" className="img-fluid cursor-pointer"
                                                                            onClick={() => setBuildingNetSuiteIds(prev =>
                                                                                prev?.map(row => {
                                                                                    if (row.id != item.id) return row;
                                                                                    // hard delete for new rows make it null, soft delete for existing
                                                                                    if (row.addUpdateFlag == 0) return null;
                                                                                    if (row.flag == 1 && row.addUpdateFlag == 1) return { ...row, flag: 0 };
                                                                                    return row;
                                                                                })?.filter(Boolean)
                                                                            )} />
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                    <div className="col-xl-3 col-12">
                                                        <button className="BorderBtn" onClick={() => {
                                                            if (allBuilding?.length == 0) {
                                                                setNewAlerts(<AlertsComp show={true} variant="danger" msg={"Please add building information before adding Netsuite IDs."} />)
                                                                setTimeout(() => {
                                                                    setNewAlerts(<AlertsComp show={false} />)
                                                                }, 2000)
                                                            } else if (allBuilding?.length == buildingNetSuiteIds?.filter(item => item.flag != 0)?.length) {
                                                                setNewAlerts(<AlertsComp show={true} variant="danger" msg={"All buildings already have Netsuite IDs assigned. Please edit existing rows to add more Netsuite IDs."} />)
                                                                setTimeout(() => {
                                                                    setNewAlerts(<AlertsComp show={false} />)
                                                                }, 2000)
                                                            }
                                                            else {
                                                                AddNewNetsuiteRow()
                                                            }
                                                        }}>
                                                            Add Building NetSuite ID
                                                        </button>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>

                                    <div className='col-12 text-start px-1 pt-3 pb-1 new-font-style'>Add Description</div>
                                    <textarea autoComplete='off' name='invoicedescription' className="form-control"
                                        value={invoiceDescription}
                                        onChange={(e) => setInvoiceDescription(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (['@', '^', '%', '#', '!', '&', '*', '/', '|', '>', '<', '?', '=', '+', '_']?.includes(e?.key)) {
                                                e.preventDefault();
                                                return false;
                                            }
                                        }}
                                    />
                                    <p className='pt-2'>
                                        <b>Note : </b>
                                        You can create a custom description using dynamic placeholders. These placeholders will be automatically replaced with actual values when generating the final output.
                                    </p>
                                    <b>Supported placeholders: </b>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <ul>
                                                <li><b>{`{$${account_name_keyword}}`}</b> – Name of the {organizationLabelSmall}</li>
                                                <li><b>{'{$serialNum}'}</b> – Serial number of the device</li>
                                                <li><b>{'{$assetTag}'}</b> – Asset tag assigned to the device</li>
                                                <li><b>{'{$deviceModel}'}</b> – Model of the device</li>
                                                <li><b>{'{$devicePurchaseDate}'}</b> – Purchase date of the device</li>
                                                <li><b>{'{$deviceStatus}'}</b> – Current status of the device (e.g., Active, Loaner, Decommission)</li>
                                                <li><b>{'{$deviceBuilding}'}</b> – Building where the device is located</li>
                                                <li><b>{'{$deviceRoom}'}</b> – Room number or location of the device</li>
                                                <li><b>{'{$deviceNotes}'}</b> – Any notes about the device</li>

                                            </ul>
                                        </div>
                                        <div className='col-md-6'>
                                            <ul>
                                                <li><b>{'{$ticketNum}'}</b> – Ticket number</li>
                                                <li><b>{'{$ticketStatus}'}</b> – Current status of the ticket</li>
                                                <li><b>{'{$ticketReturnLocation}'}</b> – Location where the device should be returned</li>
                                                <li><b>{'{$ticketReworkStatus}'}</b> – Whether the ticket is a rework</li>
                                                <li><b>{'{$ticketNotes}'}</b> – Any additional notes from the ticket</li>
                                                <li><b>{'{$attachPartsDetails}'}</b> – Attached parts name</li>
                                                <li><b>{`{$${user_num_keyword}}`}</b> – {student_no} (if assigned)</li>
                                                <li><b>{'{$userFirstName}'}</b> – First name of the user</li>
                                                <li><b>{'{$userLastName}'}</b> – Last name of the user</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-12 text-end py-3">
                                        <button className="SaveBtn" onClick={handleSaveInvoiceDescription}>Save NetSuite and Pricing Information </button>
                                        <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/") }}><u>Exit</u></label>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div >
            {
                buildingAddressPopup &&
                <BuildingAddressPopup setNewAlerts={setNewAlerts} getSchoolProfileInfo={getSchoolProfileInfo} setLoading={setLoading} buildingAddressPopup={buildingAddressPopup} selectedBuildingAddress={selectedBuildingAddress}
                    closePopup={(e) => { setBuildingAddressPopup(false); setSelectedBuildingAddress({}) }} />
            }
            <Deletepopup
                text={`You won't be able to revert this!`}
                deletePopup={deletePopup.show}
                size="md"
                deletePart={(e) => {
                    if (deletePopup.item.isNew) {
                        setContacts((prevState) =>
                            prevState.filter(contact => contact.id !== deletePopup.item.id)
                        );
                        setNewAlerts(<AlertsComp show={true} variant="success" msg={"Contact removed Successfully."} />)
                        setTimeout(() => {
                            setDeletePopup({ ...deletePopup, show: false, item: null });
                            setNewAlerts(<AlertsComp show={false} />)
                        }, 2000)
                    } else {
                        handleSaveSection('MainContactDiv', validateMainContactExtras)
                    }
                    setDeletePopup({ ...deletePopup, show: !deletePopup.show, item: null })
                }}
                DeleteShowClose={(e) => setDeletePopup({ ...deletePopup, show: !deletePopup.show, item: null })} />

            <Deletepopup text={`You won't be able to revert this!`} deletePopup={showPriceDelModal} size="md"
                deletePart={(e) => { addUpdateDeleteSchoolCustomPart(3); setShowPriceDelModal(!showPriceDelModal) }}
                DeleteShowClose={(e) => setShowPriceDelModal(!showPriceDelModal)} />
        </div >
    )
}
